import React, { useState, useEffect, useRef, useMemo, useContext, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import HamburgerMenu from '../../Components/HamburgerMenu/HamburgerMenu.jsx';
import Select from 'react-select';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { registerLocale, setDefaultLocale } from "react-datepicker";
import enGB from 'date-fns/locale/en-GB';
import { useTranslation } from 'react-i18next';
import DocumentService from '../../Services/documents.service.js';
import ProjectsService from '../../Services/projects.service.js';
import UserService from '../../Services/user.service.js';
import { useOcrJobs } from '../../Contexts/OcrJobsContext';
import { useBack } from "use-back";
import './Document.scss';
import backIcon from '../../assests/images/left-arrow.png';
import calendarIcon from '../../assests/images/calendar.png';
import SubAccountantService from '../../Services/subAccountant.service.js';
import EnumsService from '../../Services/enums.service.js';
import CustomDeleteConfirmationModal from '../../Components/CustomDeleteConfirmationModal/CustomDeleteConfirmationModal.js'
import { ToastContainer, toast } from "react-toastify";
import DownloadIcon from "../../assests/images/downloadIcon.png";
import NoDocumentsPdf from "../../assests/pdf/NoDocument.pdf";
import { useSignalR } from '../../Contexts/signalR.js';
import SignaturePad from 'react-signature-canvas';
import ClientDocumentCountService from '../../Services/ClientDocumentCount.service.js';
import AuthService from '../../Services/auth.service.js';
import PuffLoader from "react-spinners/PuffLoader";
import saveIcon from "../../assests/images/save.png";
import cancelIcon from "../../assests/images/cancel.png";
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import ClientService from '../../Services/client.service.js';
import addIcon from "../../assests/images/plusO.png";
import loadingAnimation from "../../assests/images/Animation.gif";
import DraggableModal from '../../Components/DraggableModal/DraggableModal.js';
import DocumentKpiCards from '../../Components/Document/SubComponents/DocumentKpiCards.jsx';
import DuplicateEntriesModal from '../../Components/DuplicateEntriesModal/DuplicateEntriesModal.jsx';
import UpperPanelDetails from '../../Components/Widgets/UpperPanelDetails/UpperPanelDetails.jsx';
import { PDFDocument } from 'pdf-lib';
import ReportsService from '../../Services/reports.service.js';
import JournalDocumentationModal from '../../Components/Document/SubComponents/JournalDocumentationModal.jsx';
import MonthStatusModal from '../../Components/Widgets/MonthStatusModal/MonthStatusModal.jsx';
// MUI imports
import { Edit as EditIcon, Delete as DeleteIcon, Search as SearchIcon, Download as DownloadIconMui, Settings, GetApp as GetAppIcon, ContentCopy as ContentCopyIcon, Close as CloseIcon, ReceiptLong as ReceiptLongIcon } from '@mui/icons-material';
import {
    Button, Box, TextField, Checkbox,
    InputAdornment, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
    ToggleButton, ToggleButtonGroup, CircularProgress, IconButton, Tooltip,
} from '@mui/material';
import dayjs, { Dayjs } from 'dayjs';
import EditModal from '../../Components/EditModal/EditModal.js';
import CustomMonthDatePicker from '../../Components/Widgets/CustomDates/CustomMonthDatePicker/CustomMonthDatePicker.js';
import { beautifyNumber } from '../../Utils/FormatNumber.js';
import DateInput from '../../Components/DateInput/DateInput.js';
import Constants from '../../assests/Constants/constants.js';
import useCaseSystemAccountSettings from '../../hooks/useCaseSystemAccountSettings.js';
import styled from '@mui/system/styled';
import { minHeight, textAlign } from '@mui/system';
import DocumentDataGrid from '../../Components/Document/SubComponents/DocumentDataGrid.jsx';
import DocumentDraggableDialog from '../../Components/Document/SubComponents/DocumentDraggableDialog.jsx';
import CreateDocumentModal from '../../Components/Document/SubComponents/CreateDocumentModal.jsx';
import AutocompleteSelect from '../../Components/Widgets/AutocompleteSelect/AutocompleteSelect.jsx';
import { setDate } from 'date-fns';
import { calculateVatAmount, roundVatToInteger } from '../../Utils/GetVatValue.js';
import FilterMonthYearPicker from '../../Components/Widgets/CustomDates/FilterMonthYearPicker/FilterMonthYearPicker.jsx';
import headerStyles from '../../Components/ClientDetails/SubComponents/ClientDetailsHeader/HeaderToolbar.module.scss';
import { PermissionsContext } from '../../Contexts/Permissions.js';
import { NavHistoryContext } from '../../Contexts/NavHistoryContext.js';

import Swal from 'sweetalert2'; // Modern modal library
import MissingAccountCardsAlert from '../../Components/MissingAccountCardsAlert/MissingAccountCardsAlert';
import InactiveClientAlert from '../../Components/InactiveClientAlert/InactiveClientAlert';
import { validateDocumentBeforeProcessing } from '../../Utils/documentValidation.js';
import { canProcessDocumentStatus } from '../../Utils/helpers.js';
import InvoiceSelectionModal from '../../Components/Document/SubComponents/InvoiceSelectionModal.js';
import ChooseAsset from '../../Components/Widgets/ChooseAsset/ChooseAsset.js';
import AssetService from '../../Services/assets.service.js';
import AddAssetGroup from '../../Components/Assets/SubComponents/AddAssetGroup.js';
import AssetFoundDialog from '../../Components/Widgets/AssetFoundDialog/AssetFoundDialog.js';
import SelectDocumentOptionDialog from '../../Components/Widgets/SelectDocumentOptionDialog/SelectDocumentOptionDialog';
import { splitSelectedRows } from '../../Components/Widgets/SelectDocumentOptionDialog/rowSelectors';
import { useHamburgerMenu } from '../../Contexts/HamburgerMenuContext.js';
import NavigationButton from '../../Components/NavigationButton/NavigationButton.jsx';
import MultiDocumentTransferDialog from '../../Components/DocumentTransferDialog/MultiDocumentTransferDialog.js';
import DuplicateMergeModal from '../../Components/Document/SubComponents/DuplicateMergeModal.jsx';
import SupplierInvoicesModal from '../../Components/Document/SubComponents/SupplierInvoicesModal.jsx';
import TaxAuthorityService from '../../Services/taxAuthority.service.js';
import { dir } from 'i18next';
import BulkEditModal from '../../Components/PrimaryBulkActionsToolbar/BulkEditModal';
import KeyboardShortcuts from '../../Components/KeyboardShortcuts/KeyboardShortcuts.jsx';
import * as XLSX from 'xlsx';
import TableChartIcon from '@mui/icons-material/TableChart';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';

import { useClientNavigation } from '../../hooks/useClientNavigation.js';
import { fetchDocumentPageData, recalculateCreditDebit, setDocuments as setDocumentPageDocuments, setMonthClosed, resetDocumentPage } from '../../store/reducers/documentPageSlice';
import { fetchDocumentEnums, selectDocumentEnums } from '../../store/reducers/documentEnumsSlice';
import GroupingModeModal, { ALL_GROUPING_MODE_KEYS } from '../../Components/Widgets/GroupingModeModal/GroupingModeModal.jsx';

function getDocumentSegmentationId(item) {
    if (!item) return '';
    const p = item?.projects?.[0] ?? item?.segmentations?.[0];
    if (p) {
        const id = p.projectId ?? p.ProjectId ?? p.id ?? p.Id;
        if (id != null && id !== '') return String(id);
    }
    const segId =
        item.segmentationId ??
        item.SegmentationId ??
        item.segmentationProjectId ??
        item.projectId;
    if (segId != null && segId !== '') return String(segId);
    return '';
}

function documentBelongsToSegmentation(item, seg, documentType) {
    if (!seg || item?.id == null || item.id === '') return false;
    const docId = String(item.id);
    const has = (arr) => Array.isArray(arr) && arr.some((x) => String(x) === docId);
    if (documentType === 'Incomes') return has(seg.incomesIds);
    if (documentType === 'Expenses') return has(seg.expensesIds);
    return false;
}

function documentMatchesAllowedProjects(item, allowedIds, segmentationProjects, documentType) {
    if (!allowedIds) return true;
    const directId = getDocumentSegmentationId(item);
    if (directId && allowedIds.has(directId)) return true;
    return segmentationProjects.some(
        (seg) =>
            allowedIds.has(String(seg.id)) &&
            documentBelongsToSegmentation(item, seg, documentType)
    );
}

const OptionButton = styled(Button)({
    margin: '10px 8px',
    padding: '12px 25px',
    fontSize: '1.1rem',
    textTransform: 'none',
    color: '#025366',
    backgroundColor: '#f5f5f5',
    border: '1px solid #E57C22',
    width: 'auto',  // Allows the button to shrink when there are many buttons
    maxWidth: '200px',  // Set a maximum width to ensure consistency
    flexGrow: 1,  // Allows buttons to fill available space equally
    '&:hover': {
        backgroundColor: '#E57C22',
        color: '#fff',
    },
});

setDefaultLocale('en-GB'); // Set the default locale to use it
const headers = ['Dessert (100g serving)', 'Calories', 'Fat (g)'];

const rows = [
    { name: 'Frozen yoghurt', calories: 159, fat: 6.0 },

];

function Document() {
    const navigate = useNavigate();
    const { i18n, t } = useTranslation();
    const [modalVisible, setModalVisible] = useState(false);
    const { goBack } = useContext(NavHistoryContext);
    const [formData, setFormData] = useState({
        accountCodeId: '',
        accountCodeName: '',
        accountCaseId: '',
        sortCodeId: '100',
        vat: 100,
        amount: '',
        reference: '',
        reference2: '',
        confirmationNumber: '',
        uploadDate: '',
        documentDate: '',
        description: '',
        creditAccount: '4',
        debitAccount: '',
        amount: '',
        documentDate: new Date()
    });
    //invoice modal for both invoices
    const [chooseInvoiceModal, setChooseInvoiceModal] = useState(false);
    const [invoiceModalVisible, setInvoiceModalVisible] = useState(false);
    const [invoiceTypeInModal, setInvoiceTypeInModal] = useState(false);
    const [isConfirmationModal, setIsConfirmationModal] = useState(false);


    const [subAccountants, setSubAccountants] = useState([]);
    const [subAccountantOptions, setSubAccountantOptions] = useState([]);
    const [accountant, setAccountant] = useState({});

    const [signatureReferenceInvoiceModalVisible, setSignatureReferenceInvoiceModalVisible] = useState(false);
    const [currentInvoiceCreatingType, setCurrentInvoiceCreatingType] = useState('');
    const [documentDate, setDocumentDate] = useState(new Date());
    const [reportingMonthDateCreate, setReportingMonthDateCreate] = useState(new Date());
    const [documentCost, setDocumentCost] = useState('');
    const [documentVat, setDocumentVat] = useState(100);
    const [documentReference, setDocumentReference] = useState('');
    const [sortCodeId, setCodeId] = useState('');
    const [accountCodeName, setAccountCodeName] = useState('');
    const [companyId, setCompanyId] = useState('');
    const [accountCodeId, setAccountCodeId] = useState('');
    const [description, setDescription] = useState('');
    const [documents, setDocuments] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');
    const [okMessage, setOkMessage] = useState('');
    const [user, setUser] = useState(null);
    const [token, setToken] = useState('');
    const [client, setClient] = useState(null);
    const { settings: caseSystemSettings } = useCaseSystemAccountSettings(client?.caseId, token);
    const [type, setType] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const [showOnlyUnprocessed, setShowOnlyUnprocessed] = useState(false);
    const [gridFilteredData, setGridFilteredData] = useState(null);

    const compareProjectCodes = useCallback(
        (a, b) => String(a?.code ?? '').localeCompare(String(b?.code ?? ''), undefined, { numeric: true }),
        []
    );
    const [byProjectsFilterActive, setByProjectsFilterActive] = useState(false);
    const [segmentationProjects, setSegmentationProjects] = useState([]);
    const [loadingSegmentations, setLoadingSegmentations] = useState(false);
    const [selectedFromSegmentation, setSelectedFromSegmentation] = useState(null);
    const [selectedToSegmentation, setSelectedToSegmentation] = useState(null);
    const [focused, setFocused] = useState(false);
    const [alignment, setAlignment] = useState('web');

    const modalCreateDocumentRef = useRef(); // Reference to the modal content
    const dataGridRef = useRef(); // Reference to the modal content
    const modalInvoiceCreateDocumentRef = useRef();
    const signatureReferenceInvoiceModalVisibleRef = useRef();
    const fetchUserDataInFlightRef = useRef(false);
    const docFetchInFlightRef = useRef(false);
    const docFetchQueuedRef = useRef(null);
    const initialLoadDoneRef = useRef(false);
    const prevIsRangeRef = useRef(null);
    const prevUseRegistrationMonthRef = useRef(null);
    const prevTypeRef = useRef(null);

    const dispatch = useDispatch();
    // Document page loading is independent of main page loading (mainPageDataSlice).
    // We only read documentPageSlice so this page and Main can load in parallel when navigating.
    const documentPage = useSelector((state) => state.documentPageSlice || {});
    const rawDocumentsFromRedux = documentPage.documents || [];
    const pageLoading = documentPage.loading || false;
    const isClosedReportingMonthFromRedux = documentPage.isClosedReportingMonth ?? false;
    const creditDebitSumFromRedux = documentPage.creditDebitSum;
    const missingAccountCardsFromRedux = documentPage.missingCards || [];
    const vatAggregatesFromRedux = documentPage.vatAggregates;

    const documentEnumsFromRedux = useSelector((state) => selectDocumentEnums(state, client?.caseId));


    const data = useMemo(() => rawDocumentsFromRedux.map((d) => {
        const vat = calculateVatAmount(d.amount, d.vat, d.documentDate);
        return {
            ...d,
            docType: d.docType || type,
            vatAmount: vat,
            netAmount: (d.amount || 0) - vat
        };
    }), [rawDocumentsFromRedux, type]);

    const denseTableCreditDebit = useMemo(() => ({
        creditAmount: creditDebitSumFromRedux?.creditSum ?? 0,
        debitAmount: creditDebitSumFromRedux?.debitSum ?? 0
    }), [creditDebitSumFromRedux]);

    const isInitialLoad = (rawDocumentsFromRedux?.length ?? 0) === 0;

    const [sortCodeIdOptions, setSortCodeIdOptions] = useState([]);
    const [accountCardOptions, setAccountCardOptions] = useState([]);


    const [accountCardEditDownloadOptions, setAccountCardEditDownloadOptions] = useState([]);
    const [clientItems, setClientItems] = useState([]);
    const [formattedPalCodeOptions, setFormattedPalCodeOptions] = useState([]);

    const [creditAccountOptions, setCreditAccountOptions] = useState([]);
    const [debitAccountOptions, setDebitAccountOptions] = useState([]);
    const [creditAccountOption, setCreditAccountOption] = useState('');
    const [debitAccountOption, setDebitAccountOption] = useState('');
    const location = useLocation();
    const [editingRow, setEditingRow] = useState(null);
    const [editedItem, setEditedItem] = useState({});
    const [forceProcessForCurrentEdit, setForceProcessForCurrentEdit] = useState(false);
    const [oldAccountName, setOldAccountName] = useState({});
    const [oldAccountCaseId, setOldAccountCaseId] = useState({});
    const [oldAccountCardId, setOldAccountCardId] = useState({});
    const [editedPopupItem, setEditedPopupItem] = useState(true);
    const [editedAddAccountCard, setEditedAddAccountCard] = useState(false);
    const [originalAccountCardId, setOriginalAccountCardId] = useState('');
    const [sortDate, setSortDate] = useState(() => {
        const storedDateString = localStorage.getItem('Date');
        return storedDateString ? new Date(storedDateString) : new Date();
    });
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [itemIdToDelete, setItemIdToDelete] = useState(null);
    const [localLoading, setLocalLoading] = useState(false);
    const { addJobs } = useOcrJobs();
    const loading = pageLoading || localLoading;
    /** Full-page overlay: only when no data yet (initial load) or local operation. Never tied to main page loading. */
    const showPageLoadingOverlay = localLoading || (pageLoading && isInitialLoad);
    const [selectedLanguage, setSelectedLanguage] = useState(localStorage.getItem('language') || 'he');
    const [currentIndex, setCurrentIndex] = useState(-1);
    const [allowAllSelect, setAllowAllSelect] = useState(false);
    const [multiTransferMode, setMultiTransferMode] = useState(false);
    const [multiTransferOpen, setMultiTransferOpen] = useState(false);
    const [startDate, setStartDate] = useState(() => {
        const storedDateString = localStorage.getItem('StartDate');
        return storedDateString ? new Date(storedDateString) : new Date();
    });; // Start date for range
    const [endDate, setEndDate] = useState(() => {
        const storedDateString = localStorage.getItem('EndDate');
        return storedDateString ? new Date(storedDateString) : new Date();
    });; // End date for range


    const [isRange, setIsRange] = useState(() => {
        const storedIsRange = localStorage.getItem('IsRange');
        return storedIsRange === "true";
    });;
    const [useRegistrationMonth, setUseRegistrationMonth] = useState(() => {
        const storedUseRegistrationMonth = localStorage.getItem('UseRegistrationMonth');
        return storedUseRegistrationMonth === "true";
    });
    const [showDownloadModal, setShowDownloadModal] = useState(false);
    const [showDuplicatesModal, setShowDuplicatesModal] = useState(false);
    const [showDuplicateMergeModal, setShowDuplicateMergeModal] = useState(false);
    const [downloadStartDate, setDownloadStartDate] = useState(null); // Start date for range
    const [downloadEndDate, setDownloadEndDate] = useState(null);
    const [downloadAmount, setDownloadAmount] = useState();
    const [downloadAccountCodeId, setDownloadAccountCodeId] = useState([]);
    const [selectedDownloadAccountCodeId, setSelectedDownloadAccountCodeId] = useState([]);
    const [isDateEnabled, setIsDateEnabled] = useState(false);
    const { documentUpdate } = useSignalR();
    const [statusCheck, setStatusCheck] = useState(false);
    const isClosedReportingMonth = isClosedReportingMonthFromRedux;
    const [isFirstUserFetched, setIsFirstUserFetched] = useState(false);
    const [actionType, setActionType] = useState('delete');
    // invoice Details // 
    const sigPad = useRef({});
    const [invoiceDescription, setInvoiceDescription] = useState('');
    const [invoiceReference, setInvoiceReference] = useState('');
    const [invoiceClientName, setInvoiceClientName] = useState('');
    const [invoiceClientCaseId, setInvoiceClientCaseId] = useState('');
    const [invoiceClientLocation, setInvoiceClientLocation] = useState('');
    const [invoiceClientEmail, setInvoiceClientEmail] = useState('');
    const [invoiceClientPhoneNumber, setInvoiceClientPhoneNumber] = useState('');
    const [invoiceSignature, setInvoiceSignature] = useState('');
    const [invoiceAccountCodeId, setInvoiceAccountCodeId] = useState('');
    const [invoiceItems, setInvoiceItems] = useState([]);
    const [invoiceDate, setInvoiceDate] = useState(new Date());
    const [addNewItem, setAddNewItem] = useState(false);
    const [addNewAccountCard, setAddNewAccountCard] = useState(false);
    const [addNewAccountCardDocument, setAddNewAccountCardDocument] = useState(false);
    const [addNewSignatureReference, setAddNewSignatureReference] = useState(false);
    const [newItems, setNewItems] = useState([]); // To store new items
    const [addItemFlags, setAddItemFlags] = useState([]); // Array of booleans to track add new item mode per index
    const [priceIncludingVAT, setPriceIncludingVAT] = useState(false);
    const [sortConfig, setSortConfig] = useState({ key: 'uploadNumber', direction: 'descending', type: 'number' });
    const [open, setOpen] = useState(false);
    const [selectedDate, setSelectedDate] = useState(dayjs(sortDate));
    const [autoFilling, setAutoFilling] = useState(true);
    const [fade, setFade] = useState(false);
    const [denseTableHeader, setDenseTableHeader] = useState([]);
    const [denseTableRows, setDenseTableRows] = useState([]);
    const [denseTableCreditDebitHeader, setDenseTableCreditDebitHeader] = useState([]);
    const [denseTableCreditDebitRows, setDenseTableCreditDebitRows] = useState([]);
    const [includeVatBreakdown, setIncludeVatBreakdown] = useState(false);
    const missingAccountCards = missingAccountCardsFromRedux;
    const [direction, setDirection] = useState('rtl'); // Default to 'rtl'
    const [currentRowData, setCurrentRowData] = useState(null);
    const [openInlineEditModal, setOpenInlineEditModal] = useState(null);
    const [complexDepositsChecked, setComplexDepositsChecked] = useState(false);
    const [debitCreditSum, setDebitCreditSum] = useState(0);
    const [creditSum, setCreditSum] = useState(0);
    const [debitSum, setDebitSum] = useState(0);
    const { hasBack, handleBack } = useBack();
    const { userTypeContext, permissionsState, clientPermissionsState } = useContext(PermissionsContext);
    const isClient = useMemo(() => {
        return userTypeContext?.toString() === Constants.UserType.Client;
    }, [userTypeContext]);

    const hideStatusBadge = clientPermissionsState?.CantSeeStatusDocuments && isClient;
    const canProcessStatus = canProcessDocumentStatus(userTypeContext, permissionsState, hideStatusBadge);
    const { viewDocumentCreate } = useClientNavigation(client);

    useEffect(() => {
        // Update direction based on the current language
        if (i18n.language === 'he' || i18n.language === 'ar') {
            setDirection('rtl');
        } else {
            setDirection('ltr');
        }
    }, [i18n.language]);

    const handleSignatureChange = () => {
        if (sigPad.current) {
            const signatureImage = sigPad.current.getTrimmedCanvas().toDataURL('image/png');
            setInvoiceSignature(signatureImage);
        }
    };
    // const [toastPosition, setToastPosition] = useState('')
    const [selectedRows, setSelectedRows] = useState([]);
    const [allSelected, setAllSelected] = useState(false);
    const [openOptions, setOpenOptions] = useState(false);
    const [bulkEditOpen, setBulkEditOpen] = useState(false);
    const [isAllSelected, setIsAllSelected] = useState(false);
    const [showAddGroupModal, setShowAddGroupModal] = useState(false);
    const [assetGroups, setAssetGroups] = useState([]);
    const { setMenuProps, editModalUpdated, setEditModalUpdated, openWithholdingTaxModel } = useHamburgerMenu();
    useEffect(() => {
        setMenuProps({ client });
    }, [client, setMenuProps]);
    const handleOpenGroudAdd = () => {
        setShowAddGroupModal(true);
    }

    const setOpenOption = () => setOpenOptions(true);
    const closeOptions = () => {
        handleDeselect(selectedRows);
        setOpenOptions(false);
        setSelectedRows([]); // Unselect all rows
        setIsAllSelected(false); // Uncheck the "Select all" checkbox
    };

    const isSelected = (id) => selectedRows.indexOf(id) !== -1;

    const handleSelectRows = (ids) => {

        if (ids && ids.length === 0) {
            setSelectedRows([]);
            return
        }
        setSelectedRows(ids);

        // let newSelected = [...selectedRows]; // Start with the current selected IDs

        // ids.forEach((id) => {
        //     // Find the item in filteredAndSortedData that matches the selected id
        //     const item = filteredAndSortedData.find((row) => row.id === id);
        //     if (!item) return; // Skip if the item with the given id isn't found

        //     // Apply the same condition used for displaying checkboxes
        //     const condition = client.accountManagement === Constants.AccountManagementOptions[0].name
        //         ? item.sortCodeId && item.creditAccount && item.debitAccount
        //         : item.sortCodeId;

        //     if (!condition) return; // Skip if the item doesn't meet the condition

        //     // Check if the id is already in selectedRows
        //     const selectedIndex = newSelected.indexOf(id);

        //     // Add or remove the id based on its presence in selectedRows
        //     if (selectedIndex === -1) {
        //         // ID is not selected, so add it
        //         newSelected.push(id);
        //     } else {
        //         // ID is selected, so remove it
        //         newSelected.splice(selectedIndex, 1);
        //     }
        // });


        // setSelectedRows(newSelected);
    };


    const handleDeselect = (ids) => {
        if (dataGridRef.current) {
            dataGridRef.current.deselectRows(ids); // Call deselectRow on the ref
        }
    };


    const handleSelectAllClick = (event) => {
        const checked = event.target.checked;
        setIsAllSelected(checked);

        if (checked) {
            // Filter items based on the condition before selecting
            const newSelecteds = filteredAndSortedData
                .filter((item) => {
                    // Apply the same condition used for displaying checkboxes
                    const condition = client.accountManagement === Constants.AccountManagementOptions[0].name
                        ? item.sortCodeId && item.creditAccount && item.debitAccount
                        : item.sortCodeId;
                    return condition;
                })
                .map((item) => item.id);
            setSelectedRows(newSelecteds);
            setAllSelected(true);
        } else {
            setSelectedRows([]);
            setAllSelected(false);
        }
    };

    // helper ────────────────────────────────────────────────────────────────
    const safeFetch = async (promise, {
        successKey,               // i18n success key
        defaultErrorKey,          // i18n fallback error key
        extraErrorHandler = null, // optional fn(errText) → string (translated message)
    }) => {
        try {
            const res = await promise;
            if (res?.ok || res === true) {          // some calls return boolean
                toast.success(t(successKey));
                return true;
            }

            // Response returned but not OK
            let errText = '';
            try {
                errText = typeof res.text === 'function' ? await res.text() : res?.message || '';
            } catch { /* ignore */ }

            const finalMsg =
                extraErrorHandler?.(errText) ||
                t(defaultErrorKey, { errorText: errText || t('UnknownServerError') });

            toast.error(finalMsg);
        } catch (networkErr) {
            // Fetch/network/JS error
            toast.error(networkErr?.message || t('generalError'));
        }
        return false;
    };

    // main ──────────────────────────────────────────────────────────────────
    const handleOptionSelect = async option => {
        if (hideStatusBadge) {
            closeOptions();
            return;
        }
        const { locked, unlocked } = splitInfo;

        /* ---------- Early-exit guards ---------- */
        if (
            (option === 'locked' && !unlocked.length) ||
            (option === 'storno' && !locked.length) ||
            ((option === 'done' || option === 'notDone') && !unlocked.length)
        ) {
            toast.info(t('NothingToProcess'));
            closeOptions();
            return;
        }

        setLocalLoading(true);
        let refreshNeeded = false;

        try {
            switch (option) {
                /* ───────── processed / unprocessed ───────── */
                case 'done':
                    handleDoneIdsClick(unlocked)
                    break;

                case 'notDone':
                    handleNotDoneIdsClick(unlocked)
                    break;

                /* ───────── lock ───────── */
                case 'locked':
                    refreshNeeded = await safeFetch(
                        DocumentService.LockDocumentsByTypeAndIds(
                            client.caseId,
                            client.accountantId,
                            unlocked,
                            token
                        ),
                        {
                            successKey: 'DocumentsLocked',
                            defaultErrorKey: 'FailedToLockDocuments',
                            extraErrorHandler: errText =>
                                errText.toLowerCase().includes('not processed')
                                    ? t('SomeRowsNotProcessed')
                                    : null,
                        }
                    );
                    break;

                /* ───────── storno ───────── */
                case 'storno':
                    await DocumentService.CreateStornoEntries(locked, client.caseId, token);

                    refreshNeeded = true;
                    break;

                default:
                    break;
            }

            /* ---------- Refresh grid once if anything succeeded ---------- */
            if (refreshNeeded) {
                if (isRange) {
                    await fetchPageData(new Date(startDate), new Date(endDate), true);
                } else {
                    await fetchPageData(new Date(sortDate), new Date(sortDate), false);
                }
            }
        } finally {
            setLocalLoading(false);
            closeOptions();
        }
    };



    useEffect(() => {
        if (currentIndex != -1) {
            setFade(true);
            const timer = setTimeout(() => setFade(false), 500);
            return () => clearTimeout(timer);
        }
    }, [currentIndex]);

    const clearSignature = () => {
        if (sigPad.current) {
            sigPad.current.clear();
            setInvoiceSignature("");
        }
    };
    // Add a new item
    const handleAddItem = () => {
        const newItem = { makat: '', name: '', quantity: 1, price: null, discount: 0 };
        setInvoiceItems([...invoiceItems, newItem]);
    };

    const handleCloseAddItem = (index) => {
        const updatedFlags = [...addItemFlags];
        updatedFlags[index] = false;
        setAddItemFlags(updatedFlags);
    };

    // Update an existing item
    const handleItemChange = (index, field, value) => {
        if (addItemFlags[index]) {
            setNewItems(prevNewItems => {
                const newItemsCopy = [...prevNewItems];
                newItemsCopy[index] = {
                    ...newItemsCopy[index],
                    [field]: value,
                    caseId: client.caseId // Assuming caseId is available here
                };
                return newItemsCopy;
            });
        }
        if (field === "discount" && (parseInt(value) > 100 || parseInt(value) < 0)) {
            return;
        }
        setInvoiceItems(prevItems => {
            const updatedItems = prevItems.map((item, idx) => idx === index ? { ...item, [field]: value } : item);
            return updatedItems;
        });
    };


    // Remove an item
    const handleRemoveItem = (index) => {
        const newItems = invoiceItems.filter((_, idx) => idx !== index);
        setInvoiceItems(newItems);
    };

    const handleListItemClick = (month) => {
        const newDate = sortDate.month(month - 1);  // month is 0-indexed in JavaScript
        setSelectedDate(newDate);
        setSortDate(newDate);
        setOpen(false);
    };


    const CloseReportingMonth = async (status) => {
        setLocalLoading(true);
        try {
            const response = await ClientService.UpdateReportingMonth(client.caseId, sortDate, status, token);
            if (response.ok) {
                toast.success(
                    status ? t('MonthReportClosedSuccess') : t('MonthReportOpenedSuccess'), {
                    position: direction === 'rtl' ? 'top-left' : 'top-right'
                });
                dispatch(setMonthClosed(status));
            } else {
                const errorText = await response.text();
                console.error(t('MonthReportNotClosed'), errorText);
                toast.error(
                    status ? `${t('MonthReportNotClosed')}: ${errorText}` : `${t('MonthReportNotOpened')}: ${errorText}`,
                );
            }
        } catch (error) {
            console.error(t('MonthReportNotClosed'), error);
            toast.error(status ? `${t('MonthReportNotClosed')}: ${error}` : `${t('MonthReportNotOpened')}: ${error}`,
            );
        } finally {
            setLocalLoading(false); // Stop loading regardless of the outcome
            setIsModalVisible(false)
        }
    };

    const handleDeleteClick = (itemId) => {
        setItemIdToDelete(itemId);
        setIsModalVisible(true);
    };

    const handleEditDeleteClick = (itemId) => {
        setActionType('delete')
        setEditedPopupItem(false);
        setEditedItem({});
        handleDeleteClick(itemId);
    };


    const handleOpenCreateModal = () => {
        if (client?.isActive === false) {
            toast.error(t('ClientInactiveCannotCreateDocuments'));
            return;
        }
        setModalVisible(true);
        if (type === 'Expenses') {
            setFormData({
                accountCodeId: '',
                accountCodeName: '',
                accountCaseId: '',
                sortCodeId: '',
                vat: 100,
                amount: '',
                reference: '',
                reference2: '',
                confirmationNumber: '',
                uploadDate: '',
                documentDate: '',
                description: '',
                creditAccount: '',
                debitAccount: '',
                amount: '',
                documentDate: new Date(),
                registrationMonthDate: new Date(sortDate).toISOString(),
                reportingMonthDate: new Date(sortDate).toISOString()
            });
        } else {
            setFormData({
                accountCodeId: '',
                accountCodeName: '',
                accountCaseId: '',
                sortCodeId: '100',
                vat: 100,
                amount: '',
                reference: '',
                reference2: '',
                confirmationNumber: '',
                uploadDate: '',
                documentDate: '',
                description: '',
                creditAccount: '4',
                debitAccount: '',
                amount: '',
                documentDate: new Date(),
                registrationMonthDate: new Date(sortDate).toISOString(),
                reportingMonthDate: new Date(sortDate).toISOString()
            });
        }
    }

    const [saleEquipment, setSaleEquipment] = useState(false);
    const [dateForAsset, setDateForAsset] = useState(new Date().toISOString());
    const [clickedAsset, setClickedAsset] = useState(null);




    const isDepreciationDocument = (itemId, sortCodeId) => {
        const item = data.find((d) => d.id === itemId);
        if (!item) return false; // If the item is not found, allow processing
        setItemForAssets(item);
        setDateForAsset(item.documentDate);
        const sortCode = sortCodeIdOptions.find((option) => option.sortCodeId === sortCodeId);
        if (!sortCode) return false; // If the sort code is not found, allow processing

        const isItemUsedInAssets = assets.some(
            (asset) => asset.expenseId === itemId || asset.journalEntryId === itemId
        );

        const name = sortCode.sortCodeName?.trim().replace(/\s+/g, ' ') || "";
        const saleEquipmentRegex = /(מכירה|מכירת).*ציוד|ציוד.*(מכירה|מכירת)/;
        if (sortCode.sortCodeId === caseSystemSettings.fixedAssetSaleSortCode || saleEquipmentRegex.test(name)) {

            setSaleEquipment(true);
            return true;
        }


        setSaleEquipment(false);
        return Boolean(Constants.depreciationAssetSortCodeType[sortCode.sortCodeVatType]);
    };

    const isEquipmentSortCode = (sortCodeId) => {
        if (sortCodeId == null || sortCodeId === '') return false;
        const sortCode = sortCodeIdOptions.find(
            (option) => String(option.sortCodeId) === String(sortCodeId)
        );
        if (!sortCode) return false;
        return Boolean(Constants.depreciationAssetSortCodeType[sortCode.sortCodeVatType]);
    };

    const findAssetLinkedToDocument = (documentId) => {
        if (!documentId || !Array.isArray(assets) || assets.length === 0) return null;
        return assets.find(
            (asset) =>
                String(asset.expenseId) === String(documentId) ||
                String(asset.journalEntryId) === String(documentId)
        ) || null;
    };

    const [showChooseAsset, setShowChooseAsset] = useState(false);
    const [itemToAddToAsset, setItemToAddToAsset] = useState('');
    const [itemForAssets, setItemForAssets] = useState({});
    const [openJournalDocModal, setOpenJournalDocModal] = useState(false);
    const [journalDocSortBy, setJournalDocSortBy] = useState('uploadNumber');
    const [journalDocSortDirection, setJournalDocSortDirection] = useState('asc');
    const [supplierInvoicesModalOpen, setSupplierInvoicesModalOpen] = useState(false);
    const [showMonthStatusModal, setShowMonthStatusModal] = useState(false);

    const handleAssetClicked = (asset, item) => {
        setItemToAddToAsset(item.id);
        setItemForAssets(item);
        setClickedAsset(asset);
        setShowChooseAsset(true);
    };

    const handleAssetClose = () => {
        setShowChooseAsset(false);
        setClickedAsset(null);
    }

    const handleDoneClick = async (itemId) => {
        if (!canProcessStatus) {
            return;
        }



        setLocalLoading(true);
        try {
            const processedBy = await AuthService.getCurrentUserTypeId();
            const response = await ClientDocumentCountService.removeDocumentByTypeAndId(client.caseId, client.accountantId, type, itemId, token);
            if (response.ok) {
                // Overwrite ProcessedBy in the open edit modal when re-processing
                setEditedItem(prev => (prev?.id === itemId ? { ...prev, processedBy } : prev));
                await fetchDocumentsNotification(client, token)
                toast.success(t('DocumentProcessed'), {
                    position: direction === 'rtl' ? 'top-left' : 'top-right'
                });
            } else {
                const errorText = await response.text();
                let errorMessage = t('DocumentNotProcessed', { errorText });

                // Try to parse JSON error response
                try {
                    const errorJson = JSON.parse(errorText);
                    if (errorJson.message) {
                        // Check if it's a permission error
                        if (errorJson.message.includes('Required permission: Premium')) {
                            errorMessage = t('PermissionRequiredPremium');
                        } else if (errorJson.message.includes('Access is restricted')) {
                            errorMessage = t('PermissionRequiredAccessRestricted');
                        } else {
                            errorMessage = errorJson.message;
                        }
                    }
                } catch (parseError) {
                    // If parsing fails, use the original error text
                    errorMessage = t('DocumentNotProcessed', { errorText });
                }

                toast.error(errorMessage);
            }
        } catch (error) {
            toast.error(t('DocumentNotProcessed', { errorText: error.message }));
        }
        setLocalLoading(false);
    };

    const handleNotDoneClick = async (itemId) => {
        if (!canProcessStatus) {
            return;
        }
        setLocalLoading(true);
        try {
            const response = await ClientDocumentCountService.addDocumentByTypeAndId(client.caseId, client.accountantId, type, itemId, token)

            if (response.ok) {
                setEditedItem(prev => (prev?.id === itemId ? { ...prev, processedBy: null } : prev));
                await fetchDocumentsNotification(client, token);
                toast.success(t('DocumentProcessed'), {
                    position: direction === 'rtl' ? 'top-left' : 'top-right'
                });
            } else {
                const errorText = await response.text();
                let errorMessage = t('DocumentNotProcessed', { errorText });

                // Try to parse JSON error response
                try {
                    const errorJson = JSON.parse(errorText);
                    if (errorJson.message) {
                        // Check if it's a permission error
                        if (errorJson.message.includes('Required permission: Premium')) {
                            errorMessage = t('PermissionRequiredPremium');
                        } else if (errorJson.message.includes('Access is restricted')) {
                            errorMessage = t('PermissionRequiredAccessRestricted');
                        } else {
                            errorMessage = errorJson.message;
                        }
                    }
                } catch (parseError) {
                    // If parsing fails, use the original error text
                    errorMessage = t('DocumentNotProcessed', { errorText });
                }

                toast.error(errorMessage);
            }
        } catch (error) {
            toast.error(t('DocumentNotProcessed', { errorText: error.message }));
        }
        setLocalLoading(false);
    };

    const handleDoneIdsClick = async (itemIds) => {
        if (!canProcessStatus) {
            return;
        }
        setLocalLoading(true);
        try {
            const response = await ClientDocumentCountService.removeDocumentsByTypeAndIds(client.caseId, client.accountantId, type, itemIds, token);
            if (response.ok) {
                await fetchDocumentsNotification(client, token);
                await fetchPageData(new Date(sortDate), new Date(sortDate), false);
                toast.success(t('DocumentProcessed'), {
                    position: direction === 'rtl' ? 'top-left' : 'top-right'
                });
            } else {
                const errorText = await response.text();
                toast.error(t('DocumentNotProcessed', { errorText }));
            }
        } catch (error) {
            toast.error(t('DocumentNotProcessed', { errorText: error.message }));
        }
        setLocalLoading(false);
    };

    const handleNotDoneIdsClick = async (itemIds) => {
        if (!canProcessStatus) {
            return;
        }
        setLocalLoading(true);
        try {
            const response = await ClientDocumentCountService.addDocumentsByTypeAndIds(client.caseId, client.accountantId, type, itemIds, token);
            if (response.ok) {
                await fetchDocumentsNotification(client, token);
                await fetchPageData(new Date(sortDate), new Date(sortDate), false);
                toast.success(t('DocumentProcessed'), {
                    position: direction === 'rtl' ? 'top-left' : 'top-right'
                });
            } else {
                const errorText = await response.text();
                toast.error(t('DocumentNotProcessed', { errorText }));
            }
        } catch (error) {
            toast.error(t('DocumentNotProcessed', { errorText: error.message }));
        }
        setLocalLoading(false);
    };




    const handleDownloadStartDateChange = (date) => {


        const newDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), 10));
        setDownloadStartDate(newDate);
    };

    const handleDownloadEndDateChange = async (date) => {
        const endDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), 10));
        setDownloadEndDate(endDate);
    };






    /******************************************************************
 *  SMALL UTILS
 ******************************************************************/
    const toISO = d => (typeof d === 'string' ? new Date(d) : d).toISOString();



    /******************************************************************
     *  MAIN FETCH – single combined endpoint
     ******************************************************************/
    async function fetchPageData(start, end, isRangeMode, options = {}) {
        const { backgroundRefresh = false, includeVatBreakdown: overrideIncludeVatBreakdown, force = false } = options;
        if (docFetchInFlightRef.current) {
            if (force) {
                docFetchQueuedRef.current = {
                    start,
                    end,
                    isRangeMode,
                    options: { backgroundRefresh: true, includeVatBreakdown: overrideIncludeVatBreakdown },
                };
            }
            return;
        }
        docFetchInFlightRef.current = true;
        if (!backgroundRefresh) initialLoadDoneRef.current = false;

        const startISO = toISO(start);
        const endISO = toISO(end);

        const requestKey = `${startISO}|${endISO}|${isRangeMode}|${useRegistrationMonth}`;
        try {
            await dispatch(fetchDocumentPageData({
                caseId: client.caseId,
                startDate: startISO,
                endDate: endISO,
                documentType: type,
                useRegistrationMonth,
                isRange: isRangeMode,
                accountantId: client.accountantId ?? undefined,
                includeVatBreakdown: overrideIncludeVatBreakdown !== undefined ? overrideIncludeVatBreakdown : includeVatBreakdown,
                requestKey,
                token,
                backgroundRefresh
            })).unwrap();
            initialLoadDoneRef.current = true;
        } catch (err) {
            if (!backgroundRefresh) toast.error(t('documentFetchError', { errorText: err?.message || err || '' }));
        } finally {
            docFetchInFlightRef.current = false;
            const queued = docFetchQueuedRef.current;
            if (queued) {
                docFetchQueuedRef.current = null;
                await fetchPageData(queued.start, queued.end, queued.isRangeMode, queued.options);
            }
        }
    }

    // Dense table VAT comes from GetDocumentPageData response (detailedVat + top-level incomeVat), stored in Redux as vatAggregates.
    // On Expenses page, income = top-level incomeVat (for "VAT Transactions" column and Total VAT). Support both camelCase and PascalCase.
    const denseTableVatAggregates = useMemo(() => {
        if (!vatAggregatesFromRedux) return null;
        const num = (obj) => (obj == null ? 0 : (typeof obj === 'number' ? obj : (Number(obj.vat) || Number(obj.Vat) || 0)));
        return {
            incomeVatTotal: num(vatAggregatesFromRedux.income),
            expenseVatTotal: num(vatAggregatesFromRedux.expense),
            equipmentVatTotal: num(vatAggregatesFromRedux.equipment),
            incomeDetailed: vatAggregatesFromRedux.income ?? null,
            expenseDetailed: vatAggregatesFromRedux.expense ?? null,
            equipmentDetailed: vatAggregatesFromRedux.equipment ?? null,
        };
    }, [vatAggregatesFromRedux]);

    useEffect(() => {
        const source = gridFilteredData;
        const isGridSubset = !!(source && data?.length && (
            source.length !== data.length || data.some((r) => !source.some((s) => s.id === r.id))
        ));
        if (isGridSubset) return;
        if (data.length > 0 || denseTableVatAggregates) {
            const eq = denseTableVatAggregates?.equipmentVatTotal ?? 0;
            const inc = denseTableVatAggregates?.incomeVatTotal ?? 0;
            const exp = denseTableVatAggregates?.expenseVatTotal ?? 0;
            extractVatByType(data, eq, inc, exp, denseTableVatAggregates, includeVatBreakdown, false);
        }
    }, [data, denseTableVatAggregates, includeVatBreakdown, gridFilteredData]);

    // Sync Redux document enums to local state when we have enums for the current client.
    // Support both camelCase and PascalCase so vars are set correctly regardless of API response shape.
    useEffect(() => {
        if (!documentEnumsFromRedux || !client?.caseId) return;
        const e = documentEnumsFromRedux;
        const get = (camel, pascal) => e[camel] ?? e[pascal] ?? [];
        const getObj = (camel, pascal) => e[camel] ?? e[pascal];
        setSortCodeIdOptions(get('sortCodeIdOptions', 'SortCodeIdOptions') || []);
        setAccountCardOptions(get('accountCardOptions', 'AccountCardOptions') || []);
        setCreditAccountOptions(get('creditAccountOptions', 'CreditAccountOptions') || []);
        setDebitAccountOptions(get('debitAccountOptions', 'DebitAccountOptions') || []);
        setAccountCardEditDownloadOptions(get('accountCardEditDownloadOptions', 'AccountCardEditDownloadOptions') || []);
        setClientItems(get('clientItems', 'ClientItems') || []);
        setFormattedPalCodeOptions(get('formattedPalCodeOptions', 'FormattedPalCodeOptions') || []);
        setAssets(get('assets', 'Assets') || []);
        setAssetGroups(get('assetGroups', 'AssetGroups') || []);
        setSubAccountants(get('subAccountants', 'SubAccountants') || []);
        setSubAccountantOptions(get('subAccountantOptions', 'SubAccountantOptions') || []);
        const acc = getObj('accountant', 'Accountant');
        if (acc) setAccountant(acc);
        if (e.assetsError ?? e.AssetsError) toast.error(t('FailedToFetchAssets'));
        if (e.subAccountantsError ?? e.SubAccountantsError) toast.error(t('fetchSubAccountantsDataError'));
        setIsFirstUserFetched(true);
    }, [documentEnumsFromRedux, client?.caseId]);

    const handleConfirm = async () => {
        if (actionType === 'delete') {
            await handleConfirmDelete();
        } else if (actionType === 'closeMonth') {
            await CloseReportingMonth(true);
        } else if (actionType === 'openMonth') {
            await CloseReportingMonth(false);
        }
    };

    const getConfirmMessage = () => {
        switch (actionType) {
            case 'closeMonth':
                return t('AreYouSureCloseMonth');
            case 'openMonth':
                return t('AreYouSureOpenMonth');
            default:
                return t('confirmDeleteMessage');

        }
    };

    const getTitleMessage = () => {
        switch (actionType) {

            case 'closeMonth':
                return t('ConfirmCloseMonth');
            case 'openMonth':
                return t('ConfirmOpenMonth');
            default:
                return t('confirmDeleteTitle');
        }
    };

    const handleConfirmDelete = async () => {
        // Perform delete operation
        setLocalLoading(true);
        setIsModalVisible(false);
        try {
            const response = await DocumentService.DeleteDocument(type, itemIdToDelete, token);
            if (response.ok) {
                if (isRange) {
                    await fetchPageData(new Date(startDate), new Date(endDate), true)
                }
                else
                    await fetchPageData(new Date(sortDate), new Date(sortDate), false);

                // Show success toast
                toast.success(t("documentDeleteSuccess"), {
                    position: direction === 'rtl' ? 'top-left' : 'top-right'
                });
            } else {
                // Handle any errors or display an error toast

                const errorResponse2 = await response.text();


                if (errorResponse2 === 'Income is user-generated and cannot be deleted') {
                    toast.error(t("Income is user-generated and cannot be deleted"));
                } else {
                    toast.error(t("documentDeleteError"));
                }

            }
        } catch (error) {
            console.error('Error deleting document:', error);

            // Show error toast
            toast.error(t("documentDeleteError"));
        }
        setLocalLoading(false);
    };


    // const handleEdit = (item, isPopup = true) => {
    //     setEditingRow(item.id);
    //     setEditedItem({ ...item }); // create a copy of the item for editing
    //     let statusChecked = type == "Incomes" ? client.documentIds.incomes.includes(item.id) : client.documentIds.expenses.includes(item.id);
    //     setStatusCheck(!statusChecked);
    //     setEditedPopupItem(isPopup);

    // };

    const handleEdit = (item, index, isPopup = true) => {


        setEditingRow(item.id);
        // Preserve item.docType if it exists (e.g., from cross-type duplication), otherwise use page type
        item.docType = item.docType || type;
        // Navigate based on the currently visible (searched/filtered) rows, not the full data set.
        const navigationData = gridFilteredData ?? filteredAndSortedData;
        const navIndex = navigationData.findIndex((row) => row.id === item.id);
        setCurrentIndex(navIndex >= 0 ? navIndex : index);
        // Use item.docType for status check if available, otherwise fall back to type
        const docTypeForStatus = item.docType || type;
        let statusChecked = docTypeForStatus === "Incomes" ? (client.documentIds?.incomes ?? []).includes(item.id) : (client.documentIds?.expenses ?? []).includes(item.id);
        item.status = statusChecked ? 'notDone' : 'done';
        setStatusCheck(!statusChecked);
        setEditedPopupItem(isPopup);
        setEditedItem({ ...item });

    };

    const handleReopenEdit = async (item, index) => {
        await fetchEnums(user, token, client);
        handleEdit(item, index);
    };


    const handlePrevious = () => {
        // Navigate within the currently visible (searched/filtered) rows, not the full data set.
        const navigationData = gridFilteredData ?? filteredAndSortedData;
        const resolvedIndex = navigationData.findIndex((row) => row.id === editedItem?.id);
        const baseIndex = resolvedIndex >= 0 ? resolvedIndex : currentIndex;
        if (baseIndex > 0) {
            const newIndex = baseIndex - 1;
            setCurrentIndex(newIndex);
            const item = navigationData[newIndex];
            // Preserve item.docType if it exists, otherwise use page type
            item.docType = item.docType || type;
            const docTypeForStatus = item.docType || type;
            let statusChecked = docTypeForStatus === "Incomes" ? (client.documentIds?.incomes ?? []).includes(item.id) : (client.documentIds?.expenses ?? []).includes(item.id);
            setStatusCheck(!statusChecked);
            setEditedItem({ ...item });

        }
    };

    const handleNext = () => {

        // Navigate within the currently visible (searched/filtered) rows, not the full data set.
        const navigationData = gridFilteredData ?? filteredAndSortedData;
        const resolvedIndex = navigationData.findIndex((row) => row.id === editedItem?.id);
        const baseIndex = resolvedIndex >= 0 ? resolvedIndex : currentIndex;
        if (baseIndex < navigationData.length - 1) {
            const newIndex = baseIndex + 1;
            setCurrentIndex(newIndex);
            const item = navigationData[newIndex];
            // Preserve item.docType if it exists, otherwise use page type
            item.docType = item.docType || type;
            const docTypeForStatus = item.docType || type;
            let statusChecked = docTypeForStatus === "Incomes" ? (client.documentIds?.incomes ?? []).includes(item.id) : (client.documentIds?.expenses ?? []).includes(item.id);
            setStatusCheck(!statusChecked);
            setEditedItem({ ...item });
        }
    };

    const handleToggleButtonChange = (event, newAlignment) => {
        setAlignment(newAlignment);
    };

    const currentSortCode = useMemo(
        () => sortCodeIdOptions?.find((option) => option.sortCodeId === editedItem.sortCodeId) ?? null,
        [sortCodeIdOptions, editedItem.sortCodeId]
    );
    const currentSortCodeVatLabel = useMemo(
        () => (currentSortCode && Constants.SortCodeVatType ? Constants.SortCodeVatType[currentSortCode.sortCodeVatType] : null),
        [currentSortCode]
    );
    const isJournalEntryDocument = editedItem.docType === 'JournalEntries';
    const journalSortCodeIsIncome = isJournalEntryDocument && currentSortCodeVatLabel === 'VatTransactions';
    const journalSortCodeIsExpense = isJournalEntryDocument && currentSortCodeVatLabel === 'VatExpenses';

    const updateAccountFields = (newValue, accountType) => {

        const isIncomesDebit = editedItem.docType === 'Incomes' && accountType === 'debitAccount';
        const isExpensesCredit = editedItem.docType === 'Expenses' && accountType === 'creditAccount';
        const shouldSyncPrimaryFields = isIncomesDebit || isExpensesCredit;
        const shouldSyncAccountCaseOnly =
            !shouldSyncPrimaryFields &&
            ((journalSortCodeIsIncome && accountType === 'debitAccount') ||
                (journalSortCodeIsExpense && accountType === 'creditAccount'));

        const nextAccountId = newValue ? newValue.cardId : '';
        const nextAccountName = newValue ? newValue.name : '';
        const nextAccountCaseId = newValue ? (newValue.accountCaseId ?? newValue.caseId ?? '') : '';

        // Update the edited item with the new fields
        setEditedItem((prev) => {
            const updatedItem = {
                ...prev,
                [accountType]: nextAccountId,
            };

            if (shouldSyncPrimaryFields) {
                updatedItem.accountCodeId = nextAccountId;
                updatedItem.accountCodeName = nextAccountName;
                updatedItem.accountCaseId = nextAccountCaseId;
            } else if (shouldSyncAccountCaseOnly) {
                updatedItem.accountCaseId = nextAccountCaseId;
            }

            return updatedItem;
        });
    };

    const [showAssetFoundDialog, setShowAssetFoundDialog] = useState(false);
    const [foundAsset, setFoundAsset] = useState(null);
    const fetchEnumsNoParams = async () => {
        await fetchEnums(user, token, client);
    }

    const handleChange = (field, value) => {
        const updatedValue = value;
        console.log(field, value);
        
        if (field === 'sortCodeId') {
            let depreciation = false;
            const wasEquipmentSortCode = isEquipmentSortCode(editedItem.sortCodeId);

            if (isDepreciationDocument(editedItem.id, value)) {
                depreciation = true;
                setItemToAddToAsset(editedItem.id);
                setShowChooseAsset(true);
            } else {
                setShowChooseAsset(false);
            }

            const linkedAsset = findAssetLinkedToDocument(editedItem.id);
            if (linkedAsset && !depreciation && wasEquipmentSortCode) {
                setFoundAsset(linkedAsset);
                setShowAssetFoundDialog(true);
            }


            if (!value || !sortCodeIdOptions.some((option) => option.sortCodeId === value)) {
                // Set default values for the empty state
                setEditedItem({
                    ...editedItem,
                    vat: 100, // Default VAT
                    [field]: '',
                });
                return; // Exit early since there's no valid sortCodeId
            }

            const name = sortCodeIdOptions.find(
                (option) => option.sortCodeId === value
            )?.sortCodeName || ''

            // Extract the name without the parentheses
            const nameWithoutParentheses = name.replace(/\s*\(.*?\)\s*/, '').trim();

            // Check for a number within parentheses
            const match = name.match(/\((\d+)%?/);
            let customVat = match ? parseInt(match[1], 10) : null;


            const sortCode = sortCodeIdOptions.find((sc) => sc.sortCodeId === value);
            const newVat = sortCode?.vat ?? 100;


            const accountCard = accountCardOptions.find(
                (item) => item.cardId === (type === 'Incomes' ? sortCode.debitAccount : sortCode.creditAccount)
            );

            const debit = accountCardOptions.find(
                (item) => item.cardId === sortCode.debitAccount
            );

            const credit = accountCardOptions.find(
                (item) => item.cardId === sortCode.creditAccount
            );

            const sortCodeVatTypeLabel = sortCode ? Constants.SortCodeVatType?.[sortCode.sortCodeVatType] : null;
            const isSortCodeIncome = editedItem.docType === 'JournalEntries' && sortCodeVatTypeLabel === 'VatTransactions';
            const isSortCodeExpense = editedItem.docType === 'JournalEntries' && sortCodeVatTypeLabel === 'VatExpenses';

            const derivedAccountCaseId = isSortCodeIncome
                ? (debit?.accountCaseId ?? '')
                : isSortCodeExpense
                    ? (credit?.accountCaseId ?? '')
                    : (accountCard ? accountCard.accountCaseId : editedItem.accountCaseId);



            if (value === '1') { //hova
                setEditedItem({
                    ...editedItem,
                    vat: newVat,
                    [field]: updatedValue,
                    creditAccount: null,
                    debitAccount: debit ? debit.cardId : editedItem?.debitAccount,
                    accountCodeName: accountCard ? accountCard.name : editedItem.accountCodeName,
                    accountCodeId: accountCard ? accountCard.cardId : editedItem.accountCodeId,
                    accountCaseId: derivedAccountCaseId,
                });
                return;
            }
            if (value === '2') { //z5ot
                setEditedItem({
                    ...editedItem,
                    vat: newVat,
                    [field]: updatedValue,
                    creditAccount: credit ? credit.cardId : editedItem?.creditAccount,
                    debitAccount: null,
                    accountCodeName: accountCard ? accountCard.name : editedItem.accountCodeName,
                    accountCodeId: accountCard ? accountCard.cardId : editedItem.accountCodeId,
                    accountCaseId: derivedAccountCaseId,
                });
                return;
            }


            setEditedItem({
                ...editedItem,
                vat: newVat,
                [field]: updatedValue,
                creditAccount: credit ? credit.cardId : editedItem?.creditAccount,
                debitAccount: debit ? debit.cardId : editedItem?.debitAccount,
                accountCodeName: accountCard ? accountCard.name : editedItem.accountCodeName,
                accountCodeId: accountCard ? accountCard.cardId : editedItem.accountCodeId,
                accountCaseId: derivedAccountCaseId,
            });

        }
        else if (field === 'creditAccount' || field === 'debitAccount') {

            // Use the helper function to update account fields for credit or debit account
            const newValue = accountCardOptions.find(option => option.cardId === updatedValue) || null;
            updateAccountFields(newValue, field);
        }
        else {
            // Use functional update so rapid updates (e.g. manual exchange rate) don't overwrite each other
            setEditedItem((prev) => ({
                ...prev,
                [field]: updatedValue,
            }));
        }
    };

    const handleRadioChange = async (e, options) => {
        if (!canProcessStatus) {
            return;
        }
        if (e.target.value?.toString() === 'done') {
            if (!options?.validationAlreadyDone) {
                const isValid = await validateDocumentBeforeProcessing(editedItem, t, client, options?.forceProcess === true, sortCodeIdOptions);
                if (!isValid) return;
            }
            if (options?.forceProcess) {
                setForceProcessForCurrentEdit(true);
            }
            setStatusCheck(true);
        }
        else if (e.target.value?.toString() === 'notDone') {
            setForceProcessForCurrentEdit(false);
            setStatusCheck(false);
        }

        setEditedItem({ ...editedItem, status: e.target.value });
    };

    const handleVatRadioChange = (e) => {
        setEditedItem({ ...editedItem, ["vat"]: parseFloat(e.target.value) });
    };
    const handleDateChange = (e, field) => {
        setEditedItem({ ...editedItem, [field]: e });
    };
    const setReportingMonthDate = async (selectedDate, field) => {
        if (!selectedDate) {
            return;
        }
        const newDate = new Date(Date.UTC(selectedDate.getFullYear(), selectedDate.getMonth(), 10));
        const response1 = await ClientService.CheckIfMonthClosed(client.caseId, newDate, token);
        if (response1.ok) {
            const isClosedReportingMonth = await response1.json();
            if (isClosedReportingMonth) {
                toast.info(t('MonthReportAlreadyClosedTryAgain'));
                return
            }
            else {
                if (modalVisible) {
                    setReportingMonthDateCreate(newDate);
                }
                else {

                    setEditedItem({ ...editedItem, [field]: newDate });
                }
            }
        }
    }

    const handleChangeNew = (selectedOption) => {
        if (selectedOption.value1 === "AddItem") {
            setCreditAccountOption("");
            setDebitAccountOption("");
            setAccountCodeName("");
            setAccountCodeId("");
            setCompanyId("");
            setAddNewAccountCardDocument(true);
        }
        else {
            setAccountCodeId(selectedOption.value);
            setCompanyId(selectedOption.accountCaseId);
            const accountCard = accountCardOptions.find(option => option.cardId === selectedOption.value);
            setAccountCodeName(accountCard.name);
            type === 'Incomes' ? setDebitAccountOption(accountCard.cardId) : setCreditAccountOption(accountCard.cardId)
        }
    };

    const handleInvoiceAccount = (selectedOption) => {
        if (selectedOption.value1 === 'AddItem') {
            setAddNewAccountCard(true);
        } else {
            setInvoiceClientName(selectedOption.value);
            const accountCard = accountCardOptions.find(option => option.name === selectedOption.value);
            setInvoiceAccountCodeId(accountCard.cardId);
        }
    };

    const handleInvoiceItem = (index, selectedOption) => {
        if (selectedOption.value === 'add-item') {
            const updatedFlags = [...addItemFlags];
            updatedFlags[index] = true;
            setAddItemFlags(updatedFlags);
        } else {
            const accountCard = clientItems.find(option => option.makat === selectedOption.value);
            handleItemChange(index, 'makat', accountCard.makat);
            handleItemChange(index, 'name', accountCard.name);
            // Reset flag in case it was set
            const updatedFlags = [...addItemFlags];
            updatedFlags[index] = false;
            setAddItemFlags(updatedFlags);
        }
    };
    const handleRightClickAction = async (id, status, editedItem) => {
        if (!canProcessStatus) {
            return;
        }

        if (status === 'done') {

            const isValid = await validateDocumentBeforeProcessing(editedItem, t, client, false, sortCodeIdOptions);
            if (!isValid) {
                setLocalLoading(false);
                return;
            }



            // if (client.accountManagement === Constants.AccountManagementOptions[0].name && (!editedItem.sortCodeId || !editedItem.creditAccount || !editedItem.debitAccount)) { /// means "כפולה"
            //     toast.info(t('DocumentMustHaveSortCodeCreditDebitAccountToMarkAsProcessed'));
            //     return
            // }
            // else if (!editedItem.sortCodeId) {
            //     toast.info(t('DocumentMustHaveSortCodeToMarkAsProcessed'));
            //     return
            // }
        }
        if (status == 'done') {
            await handleDoneClick(id);
        }
        else if (status == 'notDone') {
            await handleNotDoneClick(id)
        }
        if (isRange) {
            await fetchPageData(new Date(startDate), new Date(endDate), true)
        }
        else
            await fetchPageData(new Date(sortDate), new Date(sortDate), false);
    };
    const handleUpdate = async (itemIdOrItem) => {
        // When EditModal passes the item to save (e.g. with merged manual exchange rate), use it; otherwise use editedItem
        const itemToSave = (typeof itemIdOrItem === 'object' && itemIdOrItem != null && itemIdOrItem.id) ? itemIdOrItem : editedItem;
        const documentUrl = itemToSave.documentUrl;

        try {
            const forceProcessFlag = forceProcessForCurrentEdit || itemToSave.forceProcess;
            if (!hideStatusBadge && itemToSave.status === 'done') {
                const isValid = await validateDocumentBeforeProcessing(itemToSave, t, client, !!forceProcessFlag);
                if (!isValid) {
                    return false;
                }
            }
            delete itemToSave.documentUrl;

            // Use itemToSave.docType if it exists and differs from type (e.g., cross-type duplication)
            const documentType = itemToSave.docType && itemToSave.docType !== type ? itemToSave.docType : type;
            setLocalLoading(true);
            const response = await DocumentService.UpdateDocument(documentType, token, itemToSave);
            if (canProcessStatus) {
                if (itemToSave.status == 'done') {
                    await handleDoneClick(itemToSave.id);
                }
                else if (itemToSave.status == 'notDone') {
                    await handleNotDoneClick(itemToSave.id)
                }
            }

            if (editedAddAccountCard) {

                await handleAccountCardSave(itemToSave.accountCodeId, itemToSave.accountCodeName, itemToSave.accountCaseId);
                await fetchEnums(user, token, client);

            }

            if (response.ok) {
                setForceProcessForCurrentEdit(false);
                editedItem.documentUrl = documentUrl;

                if (isRange) {
                    await fetchPageData(new Date(startDate), new Date(endDate), true)
                }
                else
                    await fetchPageData(new Date(sortDate), new Date(sortDate), false);
                // Show success toast
                toast.success(t("documentUpdateSuccess"), {
                    position: direction === 'rtl' ? 'top-left' : 'top-right'
                });
                setLocalLoading(false);
                return true;
            } else {
                editedItem.documentUrl = documentUrl;

                const errorText = await response.text();
                toast.error(t("documentUpdateError"));
                setLocalLoading(false);
                return false;
            }
        } catch (error) {
            // Handle error

            // Show error toast
            setLocalLoading(false);
            setEditingRow(null);
            setEditedItem({});
            toast.error(t("documentUpdateError"));
            return false;
        }
        // ...
        return false;
    };

    const handleUpdateV2 = async (item) => {


        // setEditedPopupItem(false);
        setLocalLoading(true);


        try {
            const forceProcessFlag = forceProcessForCurrentEdit || editedItem.forceProcess;
            if (!hideStatusBadge && editedItem.status === 'done') {
                const isValid = await validateDocumentBeforeProcessing(editedItem, t, client, !!forceProcessFlag);
                if (!isValid) {
                    setLocalLoading(false);
                    return false;
                }
            }
            const documentUrl = item.documentUrl;

            delete item.documentUrl;

            const response = await DocumentService.UpdateDocument(type, token, item);
            if (canProcessStatus) {
                if (item.status == 'done') {
                    await handleDoneClick(item.id);
                }
                else if (item.status == 'notDone') {
                    await handleNotDoneClick(item.id)
                }
            }

            if (editedAddAccountCard) {

                await handleAccountCardSave(item.accountCodeId, item.accountCodeName, item.accountCaseId);
                await fetchEnums(user, token, client);

            }

            if (response.ok) {
                setForceProcessForCurrentEdit(false);
                // Reassign documentUrl back to item after successful update
                item.documentUrl = documentUrl;

                if (isRange) {
                    await fetchPageData(new Date(startDate), new Date(endDate), true)
                }
                else
                    await fetchPageData(new Date(sortDate), new Date(sortDate), false);
                // Show success toast
                toast.success(t("documentUpdateSuccess"), {
                    position: direction === 'rtl' ? 'top-left' : 'top-right'
                });
                return true;
            } else {
                // Reassign documentUrl back to item even on error to maintain state
                item.documentUrl = documentUrl;

                const errorText = await response.text();
                // Handle error

                // Show error toast
                toast.error(t("documentUpdateError"));
                return false;
            }
        } catch (error) {
            // Handle error

            // Show error toast
            setEditingRow(null);
            setEditedItem({});
            toast.error(t("documentUpdateError"));
            return false;
        }
        // setEditingRow(null);
        // setEditedItem({});

        setEditedAddAccountCard(false);
        setLocalLoading(false);
        return false;
        // Refresh or update your data list
    };

    const handleCancel = () => {
        setEditedPopupItem(false);
        setEditingRow(null);
        setEditedItem({});
        setEditedAddAccountCard(false);
    };


    const handleDocumentUpload = (event) => {
        setDocuments(Array.from(event.target.files));
    };

    const formatDate = dateString => {
        const date = new Date(dateString);
        const day = ('0' + date.getDate()).slice(-2);
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const formatDateNew = dateString => {


        const date = new Date(dateString);
        const day = ('0' + date.getDate()).slice(-2);
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    const formatMonthYearDate = dateString => {
        const date = new Date(dateString);
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const year = date.getFullYear();
        return `${month}/${year}`;
    };



    const closeCreateInvoiceModal = (e) => {
        // Check if the clicked element is the same as the event handler's element
        if (modalInvoiceCreateDocumentRef.current && !modalInvoiceCreateDocumentRef.current.contains(e.target)) {
            handleInvoiceClose();
        }
    }
    const closeSignatureInvoiceModal = (e) => {
        // Check if the clicked element is the same as the event handler's element
        if (signatureReferenceInvoiceModalVisibleRef.current && !signatureReferenceInvoiceModalVisibleRef.current.contains(e.target)) {
            handleSignatureReferenceClose();
        }
    }
    const handleClose = async () => {
        setModalVisible(false);
        setErrorMessage('');
        setOkMessage('');
        setDocumentCost("");
        setDocumentReference("");
        setCodeId("");
        setAccountCodeName("");
        setCreditAccountOption("");
        setDebitAccountOption("");
        setDescription("");
    }

    const handleInvoiceClose = async () => {
        setInvoiceDescription('');
        setInvoiceClientName('');
        setInvoiceClientCaseId('');
        setInvoiceClientLocation('');
        setInvoiceClientEmail('');
        setInvoiceAccountCodeId('');
        setInvoiceItems([]);
        setInvoiceDate(new Date());
        setInvoiceSignature('');
        setInvoiceReference('');
        setInvoiceClientPhoneNumber('');
        setAddNewAccountCard('');
        setPriceIncludingVAT(false);
        setInvoiceModalVisible(false);
        setChooseInvoiceModal(false);
    }

    const handleSignatureReferenceClose = async () => {
        setInvoiceSignature('');
        setInvoiceReference('');
        setSignatureReferenceInvoiceModalVisible(false);
    }

    const handleSignatureReferenceSave = async () => {
        setSignatureReferenceInvoiceModalVisible(false)
        setAddNewSignatureReference(true);
        setInvoiceModalVisible(true);
        setChooseInvoiceModal(true);
    }
    // const allFieldsFilled = sortCodeId && documentReference && documentCost && documentDate && creditAccountOption && debitAccountOption && accountCodeName && accountCodeId && description && photo
    const allFieldsFilled = (!autoFilling && formData.amount) || (autoFilling && documents.length > 0);
    const signatureReferenceFilled = invoiceSignature && invoiceReference;
    const allClientItemFieldsFilled = invoiceClientName && invoiceClientCaseId && invoiceItems && invoiceItems.length > 0 && invoiceItems.every(item => {
        const hasRequiredFields = item.name && item.makat && item.price && item.discount >= 0; // Check if name, makat, and price are provided
        item.quantity = item.quantity || 1; // Default quantity to 1 if not provided
        item.discount = item.discount || 0; // Default discount to 1 if not provided
        return hasRequiredFields;
    });

    const [showMultipleFilesDialog, setShowMultipleFilesDialog] = useState(false);

    const getPdfPageCount = async (file) => {
        try {
            const fileReader = new FileReader();

            // Wrap FileReader in a Promise to handle async base64 conversion
            const base64Data = await new Promise((resolve, reject) => {
                fileReader.onload = () => resolve(fileReader.result.split(',')[1]); // Remove `data:application/pdf;base64,` part
                fileReader.onerror = reject;
                fileReader.readAsDataURL(file);
            });

            // Load PDF with pdf-lib
            const pdfDoc = await PDFDocument.load(base64Data, { ignoreEncryption: true });

            // Return total page count
            return pdfDoc.getPageCount();
        } catch (error) {
            console.error('Error reading PDF pages:', error);
            throw error; // Propagate the error to the calling function
        }
    };

    const getMimeTypeFromExtension = (fileName) => {
        // Get the file extension
        const extension = fileName.split('.').pop().toLowerCase();
        const mimeTypes = {
            'pdf': 'application/pdf',
            'jpg': 'image/jpeg',
            'jpeg': 'image/jpeg',
            'png': 'image/png',
            'gif': 'image/gif',
            'bmp': 'image/bmp',
            'tiff': 'image/tiff',
            'txt': 'text/plain',
            'html': 'text/html',
            'css': 'text/css',
            'js': 'application/javascript',
            'json': 'application/json',
            'xml': 'application/xml',
            'csv': 'text/csv',
            'zip': 'application/zip',
            'rar': 'application/vnd.rar',
            '7z': 'application/x-7z-compressed',
            'doc': 'application/msword',
            'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'xls': 'application/vnd.ms-excel',
            'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'ppt': 'application/vnd.ms-powerpoint',
            'pptx': 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        };
        return mimeTypes[extension] || 'application/octet-stream';
    }

    const handleSave = async (overrideFormData = null) => {
        if (documents && documents.length > 0 && autoFilling) {

            if (documents.length > 1) {
                let totalPageCount = 0;
                for (const document of documents) {
                    const mimeType = getMimeTypeFromExtension(document.name);
                    if (mimeType === 'application/pdf') {
                        try {
                            const pageCount = await getPdfPageCount(document);
                            totalPageCount += pageCount;
                        } catch (error) {
                            console.error('Error reading PDF pages:', error);
                        }
                    } else {
                        // Non-PDF files are treated as single-page documents
                        totalPageCount += 1;
                    }
                }

                if (totalPageCount > Constants.MaximumPageNumber) {
                    toast.info(t('CannotUploadMoreThan15PagesAtOnce'));
                    return;
                }

                //here we add a ask if multiple modal
                setShowMultipleFilesDialog(true);
            } else {
                const singleDocument = documents[0];
                const mimeType = getMimeTypeFromExtension(singleDocument.name);

                if (mimeType === 'application/pdf') {
                    try {
                        const pageCount = await getPdfPageCount(singleDocument);

                        if (pageCount > Constants.MaximumPageNumber) {
                            toast.info(t('CannotUploadMoreThan15PagesAtOnce'));
                            return;
                        }
                        if (pageCount > 1) {
                            // Show the multiple files dialog for a single PDF with multiple pages
                            setShowMultipleFilesDialog(true);
                        } else {
                            // Proceed with a single file upload
                            handleOCRSave(Constants.InvoiceGroupingMode.OnePerPdfPage);
                        }
                    } catch (error) {
                        console.error('Error reading PDF pages:', error);
                        handleOCRSave(Constants.InvoiceGroupingMode.OnePerPdfPage);
                    }
                } else {
                    // If not a PDF, treat it as a single file
                    handleOCRSave(Constants.InvoiceGroupingMode.OnePerPdfPage);
                }
            }
        } else {
            handleNormalSave(overrideFormData);
        }
    };

    const handleSaveMultipleFiles = async (groupingMode) => {
        handleOCRSave(groupingMode);
    };


    const handleNormalSave = async (overrideFormData = null) => {
        if (client?.isActive === false) {
            toast.error(t('ClientInactiveCannotCreateDocuments'));
            return;
        }
        if (!allFieldsFilled) {
            setErrorMessage(t('errorFieldsNotFilled'));
            return; // Stop execution if fields are not filled
        }
        setLocalLoading(true);
        const data = overrideFormData || formData;

        const formDataDTO = new FormData();
        formDataDTO.append('CaseId', client.caseId);
        formDataDTO.append('AccountantId', user.accountantId);
        formDataDTO.append('SortCodeId', data.sortCodeId)
        formDataDTO.append('Reference', data.reference)
        formDataDTO.append('Reference2', data.reference2)
        formDataDTO.append('Amount', data.amount);
        formDataDTO.append('DocumentDate', new Date(data.documentDate).toISOString());
        formDataDTO.append('ReportingMonthDate', data.reportingMonthDate ? new Date(data.reportingMonthDate).toISOString() : new Date(sortDate).toISOString());
        formDataDTO.append('RegistrationMonthDate', data.registrationMonthDate ? new Date(data.registrationMonthDate).toISOString() : new Date(sortDate).toISOString());
        formDataDTO.append('CreditAccount', data.creditAccount);
        formDataDTO.append('DebitAccount', data.debitAccount);
        formDataDTO.append('AccountCodeName', data.accountCodeName);
        formDataDTO.append('AccountCodeId', data.accountCodeId);
        formDataDTO.append('AccountCaseId', data.accountCaseId);
        if (
            data.foreignCurrencyCode !== null &&
            data.foreignCurrencyCode !== undefined &&
            data.foreignCurrencyCode !== '' &&
            data.foreignCurrencyAmount !== null &&
            data.foreignCurrencyAmount !== undefined &&
            data.foreignCurrencyAmount !== ''
        ) {
            formDataDTO.append('ForeignCurrencyCode', data.foreignCurrencyCode);
            formDataDTO.append('ForeignCurrencyAmount', data.foreignCurrencyAmount);
            const rateType = data.exchangeRateType ?? Constants.ExchangeRateType.Representative;
            formDataDTO.append('ExchangeRateType', rateType);
            if (rateType === Constants.ExchangeRateType.Manual && data.exchangeRate != null && data.exchangeRate !== '') {
                formDataDTO.append('ExchangeRate', data.exchangeRate);
            }
        }

        // setDocuments([]);

        documents.forEach(document => {
            formDataDTO.append("documents", document, document.name);
        });
        formDataDTO.append('DocumentType', type);
        formDataDTO.append('DocumentFileType', type);
        formDataDTO.append('Description', data.description);
        formDataDTO.append('VAT', data.vat);
        const segId =
            data.segmentationId ??
            data.SegmentationId ??
            data.projects?.[0]?.projectId ??
            data.projects?.[0]?.ProjectId;
        if (segId != null && segId !== '') {
            const segIdStr = String(segId);
            formDataDTO.append('SegmentationId', segIdStr);
            formDataDTO.append('ProjectId', segIdStr);
        }
        // Keep modal open - removed setModalVisible(false);
        try {
            const response = await DocumentService.UploadDocument(type, formDataDTO, token);
            if (response.ok) {
                if (addNewAccountCardDocument) {
                    await handleAccountCardSave(accountCodeId, accountCodeName);
                    await fetchEnums(user, token, client);
                }
                toast.success(t('documentUploadSuccess'), {
                    position: direction === 'rtl' ? 'top-left' : 'top-right'
                });

                // Reset form data based on type
                if (type === 'Expenses') {
                    setFormData({
                        accountCodeId: '',
                        accountCodeName: '',
                        accountCaseId: '',
                        sortCodeId: '',
                        vat: 100,
                        amount: '',
                        reference: '',
                        reference2: '',
                        confirmationNumber: '',
                        uploadDate: '',
                        documentDate: '',
                        description: '',
                        creditAccount: '',
                        debitAccount: '',
                        amount: '',
                        documentDate: new Date(),
                        registrationMonthDate: new Date(sortDate).toISOString(),
                        reportingMonthDate: new Date(sortDate).toISOString()
                    });
                } else {
                    setFormData({
                        accountCodeId: '',
                        accountCodeName: '',
                        accountCaseId: '',
                        sortCodeId: '100',
                        vat: 100,
                        amount: '',
                        reference: '',
                        reference2: '',
                        confirmationNumber: '',
                        uploadDate: '',
                        documentDate: '',
                        description: '',
                        creditAccount: '4',
                        debitAccount: '',
                        amount: '',
                        documentDate: new Date(),
                        registrationMonthDate: new Date(sortDate).toISOString(),
                        reportingMonthDate: new Date(sortDate).toISOString()
                    });
                }

                // Clear documents and reset other states
                setDocuments([]);
                setAddNewAccountCardDocument(false);
            } else {
                const errorText = await response.text();
                toast.error(t('documentUploadError', { errorText }));
            }
        } catch (error) {
            toast.error(t('documentUploadError', { errorText: 'Error uploading document' }));
        }

        await fetchDocumentsNotification(client, token);
        if (isRange) {
            await fetchPageData(new Date(startDate), new Date(endDate), true, { force: true });
        } else {
            await fetchPageData(new Date(sortDate), new Date(sortDate), false, { force: true });
        }
        setSortConfig({ key: 'uploadNumber', direction: 'descending', type: 'number' });
        setLocalLoading(false);
    };



    const handleOCRSave = async (groupingMode = Constants.InvoiceGroupingMode.OnePerPdfPage) => {
        if (client?.isActive === false) {
            toast.error(t('ClientInactiveCannotCreateDocuments'));
            return;
        }
        if (!allFieldsFilled) {
            setErrorMessage(t('errorFieldsNotFilled'));
            return; // Stop execution if fields are not filled
        }
        setLocalLoading(true);

        const formDataDTO = new FormData();
        formDataDTO.append('CaseId', client.caseId);
        formDataDTO.append('AccountantId', user.accountantId);
        formDataDTO.append('ReportingMonthDate', formData.reportingMonthDate ? new Date(formData.reportingMonthDate).toISOString() : new Date(sortDate).toISOString());
        formDataDTO.append('RegistrationMonthDate', formData.registrationMonthDate ? new Date(formData.registrationMonthDate).toISOString() : new Date(sortDate).toISOString());
        formDataDTO.append('DocumentFileType', type);
        formDataDTO.append('VAT', formData.vat)
        formDataDTO.append('GroupingMode', groupingMode)
        if (client?.managesProject) {
            const ocrSegId =
                formData.segmentationId ??
                formData.SegmentationId ??
                formData.projects?.[0]?.projectId ??
                formData.projects?.[0]?.ProjectId;
            if (ocrSegId != null && ocrSegId !== '') {
                const segIdStr = String(ocrSegId);
                formDataDTO.append('SegmentationId', segIdStr);
                formDataDTO.append('ProjectId', segIdStr);
            }
        }
        documents.forEach(document => {
            formDataDTO.append("documents", document, document.name);
        });

        // Async enqueue: upload files to the queue and start background processing.
        // Data refresh happens when the polling useEffect detects all jobs are terminal.
        try {
            const response = await DocumentService.AsyncUploadOCRDocumentV2(type, formDataDTO, token);
            if (response.ok) {
                const result = await response.json();
                const jobIds = result.jobIds || [];

                if (jobIds.length === 0) {
                    // Enqueue succeeded but no job IDs returned — treat as unexpected
                    toast.warning(t('documentsQueuedNoJobsReturned'));
                    return;
                }

                toast.info(t('documentsQueuedForProcessing', { count: result.queued ?? jobIds.length }), {
                    position: direction === 'rtl' ? 'top-left' : 'top-right'
                });

                // Reset form data based on type
                if (type === 'Expenses') {
                    setFormData({
                        accountCodeId: '',
                        accountCodeName: '',
                        accountCaseId: '',
                        sortCodeId: '',
                        vat: 100,
                        amount: '',
                        reference: '',
                        reference2: '',
                        confirmationNumber: '',
                        uploadDate: '',
                        documentDate: '',
                        description: '',
                        creditAccount: '',
                        debitAccount: '',
                        amount: '',
                        documentDate: new Date(),
                        registrationMonthDate: new Date(sortDate).toISOString(),
                        reportingMonthDate: new Date(sortDate).toISOString()
                    });
                } else {
                    setFormData({
                        accountCodeId: '',
                        accountCodeName: '',
                        accountCaseId: '',
                        sortCodeId: '100',
                        vat: 100,
                        amount: '',
                        reference: '',
                        reference2: '',
                        confirmationNumber: '',
                        uploadDate: '',
                        documentDate: '',
                        description: '',
                        creditAccount: '4',
                        debitAccount: '',
                        amount: '',
                        documentDate: new Date(),
                        registrationMonthDate: new Date(sortDate).toISOString(),
                        reportingMonthDate: new Date(sortDate).toISOString()
                    });
                }

                // Clear documents and reset other states
                setDocuments([]);
                setAddNewAccountCardDocument(false);

                const reportingDate = formData.reportingMonthDate ? new Date(formData.reportingMonthDate) : new Date(sortDate);
                addJobs(jobIds, 'ocr', async () => {
                    await fetchDocumentsNotification(client, token);
                    if (!isRange) {
                        await fetchPageData(new Date(sortDate), new Date(sortDate), false, { force: true });
                    } else {
                        await fetchPageData(new Date(startDate), new Date(endDate), true, { force: true });
                    }
                    await fetchEnums(user, token, client);
                    setSortConfig({ key: 'uploadNumber', direction: 'descending', type: 'number' });
                }, {
                    caseId: client.caseId,
                    clientName: client.name,
                    reportingMonth: `${reportingDate.getMonth() + 1}/${reportingDate.getFullYear()}`,
                    fileCount: documents.length,
                });
            } else {
                const errorText = await response.text();
                toast.error(t('documentUploadError', { errorText }));
            }
        } catch (error) {
            toast.error(t('documentUploadError', { errorText: 'Error uploading document' }));
        } finally {
            setLocalLoading(false);
        }
    };

    const updateLocationState = async (newClientData) => {

        const updatedClientData = {
            ...location.state.client,
            ...newClientData
        };

        // Navigate with the updated client data and replace the current state
        setIsFirstUserFetched(false);
        navigate(location.pathname, {
            replace: true,
            state: { client: updatedClientData, type, sortDate }
        });
    };

    const handleSaveSignature = async () => {
        const Client = await ClientService.GetClient(token, client.caseId);
        updateLocationState(Client);

    }
    const handleAccountCardSave = async (AccountCodeId, AccountCodeName, CompanyId) => {

        let response2;
        if (type === 'Incomes') {

            response2 = await EnumsService.AddAccountCard(client.caseId, AccountCodeId, AccountCodeName, CompanyId, "לקוחות", token);

        } else {

            response2 = await EnumsService.AddAccountCard(client.caseId, AccountCodeId, AccountCodeName, CompanyId, "ספקים", token);
        }
        if (!response2.ok) {

            throw new Error(`HTTP error! status: ${response2.status}`);
        }
    };

    const saveNewItemsToDatabase = async () => {
        // Filter out undefined items
        const filteredItems = newItems.filter(item => item !== undefined);

        // Assuming EnumsService.AddClientItems expects an array of items
        const response = await EnumsService.AddClientItems(filteredItems, token);

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        // Reset newItems after saving
        setNewItems([]);
        // Optionally reset addItemFlags if necessary
        setAddItemFlags([]);

        return response;
    };
    const InvoiceModalTypes = [
        { controller: "Incomes", endPoint: "GenerateIncomePdf", type: "", TransactionDocumentType: "", TransactionDocumentTitle: "", title: "generateInvoice" },
        { controller: "Incomes", endPoint: "GenerateRefundIncomePdf", type: "", TransactionDocumentType: "", TransactionDocumentTitle: "", title: "generateCreditNote" },
    ]


    const [assets, setAssets] = useState([]);


    const fetchEnums = async (user, token, client) => {
        // Do not set localLoading here — avoids full-page overlay on refresh when document data is in Redux
        try {


            // Initiate all fetch requests in parallel
            const [
                codeIdResponse,
                accountsResponse,
                clientItemsResponse,
                palCodesResponse,
            ] = await Promise.all([
                EnumsService.GetSortCodesByAccountantId(client.accountantId, token),
                EnumsService.GetAccountCardsByCaseId(client.caseId, token),
                EnumsService.GetClientItemsByCaseId(client.caseId, token),
                EnumsService.GetPalCodesByAccountantId(client.accountantId, token)
            ]);


            // Process sortCodeIdOptions if response is okay
            if (codeIdResponse.ok) {
                const codeIdData = await codeIdResponse.json();
                setSortCodeIdOptions(codeIdData); // Assuming codeIdData is already in the correct format
            }

            // Process account options if response is okay
            if (accountsResponse.ok) {
                const accountsData = await accountsResponse.json();
                setCreditAccountOptions(accountsData);
                setDebitAccountOptions(accountsData); // Assuming both options are the same
                setAccountCardEditDownloadOptions(accountsData);
                const accountCardOptions = [{ name: t('AddAccountCard'), value1: 'AddItem' }, ...accountsData];
                setAccountCardOptions(accountCardOptions);

            }

            // Process client items if response is okay
            if (clientItemsResponse.ok) {
                const clientItemsData = await clientItemsResponse.json();
                clientItemsData.unshift({ makat: 'add-item', name: t('AddItem') });
                setClientItems(clientItemsData);
            }

            // Process palCodes if response is okay
            if (palCodesResponse.ok) {
                const palCodesData = await palCodesResponse.json();
                const formattedPalCodes = palCodesData.map(palCode => ({
                    label: palCode.palCodeId,
                    value: palCode.palCodeId
                }));
                setFormattedPalCodeOptions(formattedPalCodes);
            }

            // Second batch in parallel: assets, sub-accountant, accountant, asset groups
            const [assetResponse, result2, accountantResult, assetGroupResponse] = await Promise.all([
                AssetService.GetAllAssets(client?.caseId, token),
                SubAccountantService.GetSubAccountantByAccountantId(token, user.accountantId),
                SubAccountantService.GetAccountantById(token, user.accountantId),
                AssetService.GetAllAssetGroups(client?.caseId, token)
            ]);

            if (assetResponse?.success) {
                setAssets(assetResponse.data);
            } else {
                toast.error(t('FailedToFetchAssets'));
            }

            const enhancedAccountantResult = {
                ...accountantResult,
                subAccountantId: accountantResult?.accountantId,
            };
            setAccountant(enhancedAccountantResult);

            if (assetResponse?.success && assetGroupResponse?.success) {
                setAssetGroups(assetGroupResponse.data);
            } else if (!assetResponse?.success || !assetGroupResponse?.success) {
                toast.error(t('FailedToFetchAssets'));
            }

            if (result2) {
                const combinedSubAccountants = [enhancedAccountantResult, ...result2];

                // If client exists, add it to the combined list
                if (client) {
                    combinedSubAccountants.push({
                        subAccountantId: client.caseId,
                        name: client.name,
                    });
                }

                setSubAccountants(combinedSubAccountants);

                const combinedOptions = combinedSubAccountants.map((acc) => ({
                    value: acc.subAccountantId,
                    label: acc.name,
                }));

                setSubAccountantOptions(combinedOptions);
            } else {
                toast.error(t('fetchSubAccountantsDataError'));
            }
            //-----------------------------------------------------------------------------------------------





            setIsFirstUserFetched(true);
            // toast.success(t('enumFetchSuccess'), {
            //     position: "top-left"
            // });
        } catch (error) {
            console.error("Error fetching enum data:", error);
            toast.error(t('enumFetchError', { errorText: error.message }));
            // Handle the error appropriately
        }
    };


    const fetchDocumentsNotification = async (client, token) => {
        const documentCounts = await ClientDocumentCountService.getClientDocumentCountByCaseId(client.caseId, token);
        const enrichedClient = {
            ...client,
            totalCounts: documentCounts?.totalCounts ?? 0,
            documentCounts: documentCounts?.documentCounts ?? {},
            documentIds: documentCounts?.documentIds ?? {}, // counts-only returns no IDs; lazy-load via getClientDocumentCountByCaseId when "show only unprocessed" is enabled
        };
        setInvoiceSignature(enrichedClient.signature);

        setClient(enrichedClient);
        return enrichedClient;
    }
    useEffect(() => {
        const fetchUserData = async () => {
            if (fetchUserDataInFlightRef.current) return;
            fetchUserDataInFlightRef.current = true;
            try {
                const currentUser = await UserService.getCurrentUser();
                const currentToken = await UserService.getCurrentToken();
                if (currentUser && currentToken) {
                    setUser(currentUser);
                    setToken(currentToken);

                    if (location.state && location.state.client && location.state.type) {
                        setType(location.state.type);
                        const navClient = location.state.client;
                        const [enriched, fullClient] = await Promise.all([
                            fetchDocumentsNotification(navClient, currentToken),
                            ClientService.GetClient(currentToken, navClient.caseId),
                        ]);
                        const merged = {
                            ...enriched,
                            isActive: fullClient?.isActive !== undefined ? fullClient.isActive : enriched.isActive,
                        };
                        setClient(merged);
                        setInvoiceSignature(enriched.signature);
                        if (location.state?.start && location.state?.end) {
                            setSortDate(location.state.start);
                            setIsRange(false);
                        }
                        await dispatch(
                            fetchDocumentEnums({
                                caseId: merged.caseId,
                                accountantId: merged.accountantId,
                                token: currentToken,
                                addItemLabel: t('AddItem'),
                                addAccountCardLabel: t('AddAccountCard'),
                                clientName: merged.name,
                            })
                        ).unwrap();
                    } else {
                        setIsFirstUserFetched(true);
                    }
                } else {
                    navigate('/login');
                }
            } catch (error) {
                if (error?.name !== 'AbortError') {
                    toast.error(error?.message || t('generalError'));
                }
            } finally {
                fetchUserDataInFlightRef.current = false;
            }
        };

        setIsFirstUserFetched(false);
        fetchUserData();
    }, [location.state?.client?.caseId]);

    // When already on the page and user navigates with different type (Incomes ↔ Expenses), sync type from location
    // so the main fetch effect runs, detects type change, resets and refetches.
    useEffect(() => {
        if (location.state?.type != null && location.state.type !== type) {
            setType(location.state.type);
        }
    }, [location.state?.type, location.state?.client?.caseId, type]);

    useEffect(() => {
        Object.keys(documentUpdate).forEach(updateCaseId => {
            const update = documentUpdate[updateCaseId];
            if (client?.caseId === updateCaseId) {
                const updatedClients = {
                    ...client,
                    totalCounts: update.totalCounts,
                    documentIds: update.documentsIds,
                    documentsCount: update.documentsCount
                };
                setClient(updatedClients);
            }
        });
    }, [documentUpdate]);

    // Lazy-load full documentIds so the processed column filter can distinguish processed vs unprocessed
    useEffect(() => {
        if (!client?.caseId || !token) return;
        const ids = type === 'Incomes' ? client.documentIds?.incomes : client.documentIds?.expenses;
        if (ids !== undefined) return;

        let cancelled = false;
        (async () => {
            const full = await ClientDocumentCountService.getClientDocumentCountByCaseId(client.caseId, token);
            if (cancelled || !full) return;
            setClient(prev => prev ? { ...prev, documentIds: full.documentIds || {} } : prev);
        })();
        return () => { cancelled = true; };
    }, [client?.caseId, client?.documentIds?.incomes, client?.documentIds?.expenses, type, token]);

    // OCR job polling is handled globally by OcrJobsContext (see addJobs in handleOCRSave)


    /**
  * Build dense-table headers & rows for the current screen
  * @param {Array<Object>} data  – the document list already enriched with vatAmount / netAmount
  * @param {number} equipmentVat – equipment-VAT total (needed only on Expenses screen)
  * @param {number} incomeVat    – full income-side VAT total
  * @param {number} expenseVat   – full expense-side VAT total
  * @param {Object} vatAggregates – detailed VAT aggregates with fromExpenses/fromJournal breakdown
  * @param {boolean} includeOppositeVat – when false, hide opposite-type columns (VATExpenses/VATEquipment on Incomes, VATTransactions on Expenses)
  * @param {boolean} fromVisibleRows – when true, VAT and credit/debit are computed from the visible (filtered) rows
  */
    const extractVatByType = (data, equipmentVat = 0, incomeVat = 0, expenseVat = 0, vatAggregates = null, includeOppositeVat = false, fromVisibleRows = false) => {
        /* ---------------------------------------------------- *
         *  1)  Header + primary row
         * ---------------------------------------------------- */
        if (type === 'Incomes') {
            // Prefer backend aggregates (detailedVat) for totals — they use the same per-line rounding as the server
            const apiIncome = vatAggregates?.incomeDetailed;
            const apiExempt = apiIncome?.fromIncomes?.exemptIncome ?? 0;
            const apiJournalExempt = apiIncome?.fromJournal?.exemptIncome ?? 0;
            const totalExemptFromApi = apiExempt + apiJournalExempt;

            const taxableIncome = apiIncome ? (apiIncome.totalWithoutVat - totalExemptFromApi) : data.reduce((acc, itm) => acc + (itm.vat > 0 ? itm.netAmount : 0), 0);
            const exemptIncome = apiIncome ? totalExemptFromApi : data.reduce((acc, itm) => acc + (itm.vat === 0 ? itm.amount : 0), 0);
            const vatTransactions = apiIncome ? apiIncome.vat : data.reduce((acc, itm) => acc + itm.vatAmount, 0);
            const totalVat = includeOppositeVat ? (vatTransactions - expenseVat - equipmentVat) : vatTransactions;
            // Check if there's actual data from journal entries (not zero)
            const incomeFromJournal = apiIncome?.fromJournal;
            const hasJournalData = incomeFromJournal && (incomeFromJournal.vat > 0 || incomeFromJournal.totalWithoutVat > 0);

            if (apiIncome && hasJournalData) {
                // Detailed view: separate by source (from Incomes / from Journal). When includeOppositeVat false, omit VATExpenses/VATEquipment columns.
                const incomeFromIncomes = vatAggregates.incomeDetailed.fromIncomes;
                const headers = includeOppositeVat
                    ? [t('Source'), t('TaxableIncome'), t('ExemptIncome'), t('VATTransactions'), t('VATExpenses'), t('VATEquipment'), t('TotalVAT')]
                    : [t('Source'), t('TaxableIncome'), t('ExemptIncome'), t('VATTransactions'), t('TotalVAT')];
                setDenseTableHeader(headers);

                // totalWithoutVat = taxable net + exempt (zero-VAT); use exemptIncome from API for correct split
                const exemptFromIncomes = incomeFromIncomes?.exemptIncome ?? 0;
                const exemptFromJournal = incomeFromJournal?.exemptIncome ?? 0;
                const taxableFromIncomes = (incomeFromIncomes?.totalWithoutVat ?? 0) - exemptFromIncomes;
                const taxableFromJournal = (incomeFromJournal?.totalWithoutVat ?? 0) - exemptFromJournal;
                const totalTaxableIncome = taxableFromIncomes + taxableFromJournal;
                const totalExemptIncome = exemptFromIncomes + exemptFromJournal;
                const totalIncomeVat = (incomeFromIncomes?.vat ?? 0) + (incomeFromJournal?.vat ?? 0);
                const calculatedTotalVat = includeOppositeVat ? (totalIncomeVat - expenseVat - equipmentVat) : totalIncomeVat;

                const totalRow = {
                    Source: t('Total'),
                    TaxableIncome: beautifyNumber(totalTaxableIncome),
                    ExemptIncome: beautifyNumber(totalExemptIncome),
                    VATTransactions: beautifyNumber(totalIncomeVat),
                };
                if (includeOppositeVat) {
                    totalRow.VATExpenses = beautifyNumber(expenseVat);
                    totalRow.VATEquipment = beautifyNumber(equipmentVat);
                }
                totalRow.TotalVAT = beautifyNumber(calculatedTotalVat);
                const rows = [totalRow];

                // Add row for Incomes from Incomes screen if data exists
                if (incomeFromIncomes && (incomeFromIncomes.vat > 0 || incomeFromIncomes.totalWithoutVat > 0)) {
                    const fromIncomesRow = {
                        Source: t('FromIncomesScreen'),
                        TaxableIncome: beautifyNumber(taxableFromIncomes),
                        ExemptIncome: beautifyNumber(exemptFromIncomes),
                        VATTransactions: beautifyNumber(incomeFromIncomes.vat ?? 0),
                    };
                    if (includeOppositeVat) {
                        fromIncomesRow.VATExpenses = '';
                        fromIncomesRow.VATEquipment = '';
                    }
                    fromIncomesRow.TotalVAT = '';
                    rows.push(fromIncomesRow);
                }

                // Add row for Incomes from Journal Entry if data exists (totalWithoutVat with zero VAT → Exempt column)
                if (hasJournalData) {
                    const fromJournalRow = {
                        Source: t('FromJournalEntry'),
                        TaxableIncome: beautifyNumber(taxableFromJournal),
                        ExemptIncome: beautifyNumber(exemptFromJournal),
                        VATTransactions: beautifyNumber(incomeFromJournal.vat ?? 0),
                    };
                    if (includeOppositeVat) {
                        fromJournalRow.VATExpenses = '';
                        fromJournalRow.VATEquipment = '';
                    }
                    fromJournalRow.TotalVAT = '';
                    rows.push(fromJournalRow);
                }

                setDenseTableRows(rows);
            } else {
                // Simple view (or when includeOppositeVat is false – no VATExpenses/VATEquipment columns)
                const headers = includeOppositeVat
                    ? [t('TaxableIncome'), t('ExemptIncome'), t('VATTransactions'), t('VATExpenses'), t('VATEquipment'), t('TotalVAT')]
                    : [t('TaxableIncome'), t('ExemptIncome'), t('VATTransactions'), t('TotalVAT')];
                setDenseTableHeader(headers);

                const row = {
                    TaxableIncome: beautifyNumber(taxableIncome),
                    ExemptIncome: beautifyNumber(exemptIncome),
                    VATTransactions: beautifyNumber(vatTransactions),
                };
                if (includeOppositeVat) {
                    row.VATExpenses = beautifyNumber(expenseVat);
                    row.VATEquipment = beautifyNumber(equipmentVat);
                }
                row.TotalVAT = beautifyNumber(totalVat);
                setDenseTableRows([row]);
            }
        } else {
            // Prefer backend aggregates for expense totals
            const apiExpense = vatAggregates?.expenseDetailed;
            const apiEquipment = vatAggregates?.equipmentDetailed;
            const expenseAmount = apiExpense ? apiExpense.totalWithoutVat : data.reduce((acc, itm) => acc + itm.netAmount, 0);
            const effectiveIncomeVat = (type === 'Expenses' && !includeOppositeVat) ? 0 : incomeVat;
            const totalVat = effectiveIncomeVat - expenseVat - equipmentVat;

            // Check if there's actual data from journal entries (not zero)
            const expenseFromJournal = apiExpense?.fromJournal;
            const equipmentFromJournal = apiEquipment?.fromJournal;
            const hasJournalData = (expenseFromJournal && (expenseFromJournal.vat > 0 || expenseFromJournal.totalWithoutVat > 0)) ||
                (equipmentFromJournal && (equipmentFromJournal.vat > 0 || equipmentFromJournal.totalWithoutVat > 0));

            if (vatAggregates?.expenseDetailed && hasJournalData) {
                // Detailed view: separate by source (from Expenses / from Journal). When includeOppositeVat false, omit VATTransactions column.
                const expenseFromExpenses = vatAggregates.expenseDetailed.fromExpenses;
                const equipmentFromExpenses = vatAggregates.equipmentDetailed?.fromExpenses;

                const headers = includeOppositeVat
                    ? [t('Source'), t('ExpenseAmount'), t('VATLevies'), t('VATEquipment'), t('VATTransactions'), t('TotalVAT')]
                    : [t('Source'), t('ExpenseAmount'), t('VATLevies'), t('VATEquipment'), t('TotalVAT')];
                setDenseTableHeader(headers);

                // Calculate totals from detailed breakdown
                const totalExpenseAmount = (expenseFromExpenses?.totalWithoutVat ?? 0) + (expenseFromJournal?.totalWithoutVat ?? 0);
                const totalExpenseVat = (expenseFromExpenses?.vat ?? 0) + (expenseFromJournal?.vat ?? 0);
                const totalEquipmentVat = (equipmentFromExpenses?.vat ?? 0) + (equipmentFromJournal?.vat ?? 0);
                // When Expenses and flag off, income VAT = 0 from API. Same formula: Total VAT = income - expense - equipment.
                const effectiveIncomeVat = !includeOppositeVat ? 0 : incomeVat;
                const calculatedTotalVat = effectiveIncomeVat - totalExpenseVat - totalEquipmentVat;

                const totalRow = {
                    Source: t('Total'),
                    ExpenseAmount: beautifyNumber(totalExpenseAmount),
                    VATLevies: beautifyNumber(totalExpenseVat),
                    VATEquipment: beautifyNumber(totalEquipmentVat),
                };
                if (includeOppositeVat) totalRow.VATTransactions = beautifyNumber(incomeVat);
                totalRow.TotalVAT = beautifyNumber(calculatedTotalVat);
                const rows = [totalRow];

                // Add row for Expenses from Expenses screen if data exists
                if (expenseFromExpenses && (expenseFromExpenses.vat > 0 || expenseFromExpenses.totalWithoutVat > 0)) {
                    const fromExpensesRow = {
                        Source: t('FromExpensesScreen'),
                        ExpenseAmount: beautifyNumber(expenseFromExpenses.totalWithoutVat ?? 0),
                        VATLevies: beautifyNumber(expenseFromExpenses.vat ?? 0),
                        VATEquipment: equipmentFromExpenses ? beautifyNumber(equipmentFromExpenses.vat ?? 0) : beautifyNumber(0),
                    };
                    if (includeOppositeVat) fromExpensesRow.VATTransactions = '';
                    fromExpensesRow.TotalVAT = '';
                    rows.push(fromExpensesRow);
                }

                // Add row for Expenses from Journal Entry if data exists
                if (expenseFromJournal && (expenseFromJournal.vat > 0 || expenseFromJournal.totalWithoutVat > 0)) {
                    const fromJournalRow = {
                        Source: t('FromJournalEntry'),
                        ExpenseAmount: beautifyNumber(expenseFromJournal.totalWithoutVat ?? 0),
                        VATLevies: beautifyNumber(expenseFromJournal.vat ?? 0),
                        VATEquipment: equipmentFromJournal ? beautifyNumber(equipmentFromJournal.vat ?? 0) : beautifyNumber(0),
                    };
                    if (includeOppositeVat) fromJournalRow.VATTransactions = '';
                    fromJournalRow.TotalVAT = '';
                    rows.push(fromJournalRow);
                }

                setDenseTableRows(rows);
            } else {
                // Simple view (or when includeOppositeVat is false – no VATTransactions column)
                const headers = includeOppositeVat
                    ? [t('ExpenseAmount'), t('VATLevies'), t('VATEquipment'), t('VATTransactions'), t('TotalVAT')]
                    : [t('ExpenseAmount'), t('VATLevies'), t('VATEquipment'), t('TotalVAT')];
                setDenseTableHeader(headers);

                const row = {
                    ExpenseAmount: beautifyNumber(expenseAmount),
                    VATLevies: beautifyNumber(expenseVat),
                    VATEquipment: beautifyNumber(equipmentVat),
                };
                if (includeOppositeVat) {
                    row.VATTransactions = beautifyNumber(incomeVat);
                }
                row.TotalVAT = beautifyNumber(totalVat);
                setDenseTableRows([row]);
            }
        }

        /* ---------------------------------------------------- *
         *  2)  Credit / Debit difference row
         * ---------------------------------------------------- */
        setDenseTableCreditDebitHeader([
            t('Difference'),
            t('Credit Account'),
            t('Debit Account')
        ]);

        if (fromVisibleRows) {
            let creditSum = 0;
            let debitSum = 0;
            (data || []).forEach((item) => {
                const amount = parseFloat(item.amount) || 0;
                if (item.creditAccount) creditSum += amount;
                if (item.debitAccount) debitSum += amount;
            });
            creditSum = Math.round(creditSum * 100) / 100;
            debitSum = Math.round(debitSum * 100) / 100;
            const visibleDiff = Math.round((debitSum - creditSum) * 100) / 100;
            setDenseTableCreditDebitRows([{
                Difference: beautifyNumber(visibleDiff),
                TotalCreditAccount: beautifyNumber(creditSum),
                TotalDebitAccount: beautifyNumber(debitSum)
            }]);
            return;
        }

        const diff = (denseTableCreditDebit.debitAmount ?? 0) -
            (denseTableCreditDebit.creditAmount ?? 0);

        setDenseTableCreditDebitRows([{
            Difference: beautifyNumber(diff),
            TotalCreditAccount: beautifyNumber(denseTableCreditDebit.creditAmount ?? 0),
            TotalDebitAccount: beautifyNumber(denseTableCreditDebit.debitAmount ?? 0)
        }]);
    };



    const handleDownloadDocuments = async () => {
        setLocalLoading(true);
        try {
            const dto = {
                CaseId: client.caseId,
                Date: downloadStartDate,
                EndDate: downloadEndDate,
                AccountCodeIds: downloadAccountCodeId,
                Amount: downloadAmount
            };

            const blob = await DocumentService.DownloadCustomDocuments(type, token, dto); // Assuming you have token state or prop for authorization
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'documents.zip'); // or any other extension
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
            // toast.success(t('documentDownloadSuccess'));
        } catch (error) {
            console.error('Error downloading documents:', error);
            toast.error(t('documentDownloadError', { errorText: error.message }));
        }
        setDownloadStartDate(null);
        setDownloadEndDate(null);
        setDownloadAmount();
        setDownloadAccountCodeId([]);
        setShowDownloadModal(false)
        setLocalLoading(false);
    };

    const handleDownloadJournalEntryDocumentation = async () => {
        setOpenJournalDocModal(true);
    };

    // The modal payload carries the report options plus every filter field; the reports
    // service decides which of them end up in the request body.
    const onSubmitJournalDocumentation = async (options) => {
        const {
            types,
            sortBy,
            sortDirection,
            format,
            startDate: modalStart,
            endDate: modalEnd,
            includeDescription = true,
            documentIds = null,
        } = options;
        setLocalLoading(true);
        try {
            const StartDate = modalStart ? modalStart : (isRange ? startDate : sortDate);
            const EndDate = modalEnd ? modalEnd : (isRange ? endDate : sortDate);
            const selectedTypes = (types && types.length > 0) ? types : [type?.toLowerCase()];
            // The modal decides the scope: a row selection or a filtered report over the whole period.
            const finalDocumentIds = documentIds;
            const filters = options;

            if (format === 'excel') {
                const blob = await ReportsService.getJournalEntryDocumentationExcel(
                    client.caseId,
                    StartDate,
                    EndDate,
                    selectedTypes,
                    token,
                    sortBy,
                    sortDirection,
                    includeDescription,
                    finalDocumentIds,
                    filters
                );
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `JournalDocumentation-${client.caseId}.xlsx`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } else {
                // PDF
                const blob = (selectedTypes.length > 1)
                    ? await ReportsService.getJournalEntryDocumentationCombinedPdf(
                        client.caseId,
                        StartDate,
                        EndDate,
                        selectedTypes,
                        token,
                        sortBy,
                        sortDirection,
                        includeDescription,
                        finalDocumentIds,
                        filters
                    )
                    : await ReportsService.getJournalEntryDocumentation(
                        client.caseId,
                        StartDate,
                        EndDate,
                        selectedTypes[0],
                        token,
                        sortBy,
                        sortDirection,
                        includeDescription,
                        finalDocumentIds,
                        filters
                    );

                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `JournalDocumentation-${client.caseId}.pdf`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            }
        } catch (error) {
            console.error('Error downloading journal documentation:', error);
            toast.error(t('documentDownloadError', { errorText: error.message }));
        }
        setOpenJournalDocModal(false);
        setLocalLoading(false);
    };



    const handleSetInvoiceDate = async (date) => {
        const response1 = await ClientService.CheckIfMonthClosed(client.caseId, date, token);
        const isClosedReportingMonth = await response1.json();
        if (isClosedReportingMonth) {
            toast.info(t('MonthReportAlreadyClosedTryAgain'));
            return
        }
        setInvoiceDate(date)
    }

    /**
     * Opens the Tax Authority consent window and waits for the client to finish authorizing. The
     * supplier invoice API needs the same invoices scope the document flows use, so a client that
     * has never connected (or whose refresh token has lapsed) has to go through consent first.
     */
    const completeTaxAuthorityAuth = async (authUrl) => {
        const width = 600;
        const height = 600;
        const left = window.screen.width / 2 - width / 2;
        const top = window.screen.height / 2 - height / 2;
        const authWindow = window.open(
            authUrl,
            '_blank',
            `width=${width},height=${height},left=${left},top=${top}`
        );
        if (!authWindow) {
            throw new Error(t('tokenFetchError'));
        }

        const maxAttempts = 25;
        for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
            if (authWindow.closed) {
                throw new Error(t('Authentication window was closed by the user.'));
            }
            const status = await TaxAuthorityService.checkAuthCompletionClient(
                client.caseId,
                Constants.TaxAuthorityScopes.CreationNumber
            );
            if (status?.completed) {
                authWindow.close();
                return;
            }
            await new Promise((resolve) => setTimeout(resolve, 3000));
        }

        if (!authWindow.closed) authWindow.close();
        throw new Error(t('tokenFetchError'));
    };

    const handleCompareSupplierInvoices = async (params) => {
        // Consent is requested up front rather than after a failed compare, so the user is not shown
        // a token error for something the flow can resolve on its own.
        const tokenData = await TaxAuthorityService.requestTokenClient(
            client.caseId,
            token,
            Constants.TaxAuthorityScopes.CreationNumber
        );
        if (tokenData?.authUrl) {
            await completeTaxAuthorityAuth(tokenData.authUrl);
        }

        return await TaxAuthorityService.compareSupplierInvoices(params, token);
    };

    const handleImportSupplierInvoices = async (params) =>
        await TaxAuthorityService.importSupplierInvoices(params, token);

    const handleSupplierInvoicesImported = (response) => {
        const created = response?.createdCount ?? 0;
        const linked = response?.linkedCount ?? 0;
        const failed = response?.failedCount ?? 0;
        const position = direction === 'rtl' ? 'top-left' : 'top-right';

        if (created > 0 || linked > 0) {
            toast.success(t('SupplierInvoicesImportSuccess', { created, linked }), { position });
            RefreshPage();
        }

        if (failed > 0) {
            // Each failure carries its own reason (a closed reporting month, a locked expense), so the
            // first one is surfaced instead of a bare count.
            const firstError = response?.results?.find((entry) => !entry.success)?.error;
            toast.error(
                t('SupplierInvoicesImportPartialFailure', { failed, error: firstError || '' }),
                { position }
            );
        }
    };

    // Main document fetch: when dates, range, type (Incomes/Expenses), or Data View (reporting/registration month) change.
    // When page type changes: reset everything (Redux + local UI) and refetch as if first time.
    // When we already have data in Redux (e.g. after refresh): refetch in background without loading overlay so updates/deletes are reflected.
    useEffect(() => {
        if (!client?.caseId || !type) return;
        const typeChanged = prevTypeRef.current !== null && prevTypeRef.current !== type;
        prevTypeRef.current = type;

        if (typeChanged) {
            dispatch(resetDocumentPage());
            setSearchQuery('');
            setShowOnlyUnprocessed(false);
            setSortConfig({ key: 'uploadNumber', direction: 'descending', type: 'number' });
        }

        const modeChanged =
            prevIsRangeRef.current !== null &&
            (prevIsRangeRef.current !== isRange || prevUseRegistrationMonthRef.current !== useRegistrationMonth);
        prevIsRangeRef.current = isRange;
        prevUseRegistrationMonthRef.current = useRegistrationMonth;
        const shouldFetch = isFirstUserFetched || modeChanged || typeChanged;
        if (!shouldFetch) return;

        const hasExistingData = (rawDocumentsFromRedux?.length ?? 0) > 0;
        const backgroundRefresh = hasExistingData && !typeChanged && !modeChanged;

        if (modeChanged && !typeChanged) dispatch(setDocumentPageDocuments([]));
        if (!isRange) fetchPageData(sortDate, sortDate, false, { backgroundRefresh });
        else fetchPageData(startDate, endDate, true, { backgroundRefresh });
    }, [isFirstUserFetched, useRegistrationMonth, client?.caseId, type, isRange, sortDate, startDate, endDate]);







    const [openedIframeUrl, setOpenedIframeUrl] = useState('');
    const [bigIframeModalOpen, setBigIframeModalOpen] = useState(false);
    const openPdfInNewTab = (pdfUrl) => {
        // window.open(pdfUrl, '_blank');
        setOpenedIframeUrl(pdfUrl ? pdfUrl : NoDocumentsPdf);
        setBigIframeModalOpen(true);
    };
    const handleCloseIframeModal = () => {
        setBigIframeModalOpen(false);
        setOpenedIframeUrl('');
    };






    const handleSortChange = (key, type, Direction = '') => {
        let direction = Direction || 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction, type });
    };

    const loadSegmentationProjects = useCallback(async () => {
        if (!client?.caseId || !token) return;
        setLoadingSegmentations(true);
        try {
            const res = await ProjectsService.getProjects(client.caseId, token);
            if (!res.ok) {
                toast.error(t('ErrorRetrievingProjects'));
                return;
            }
            const raw = await res.json();
            const list = Array.isArray(raw) ? raw : [];
            const mapped = list
                .map((p) => ({
                    id: String(p.id ?? p.projectId ?? p.Id ?? ''),
                    code: p.code ?? p.Code ?? '',
                    name: p.name ?? p.Name ?? '',
                    label: `${p.code ?? p.Code ?? ''} — ${p.name ?? p.Name ?? ''}`,
                    incomesIds: p.incomesIds ?? p.IncomesIds ?? [],
                    expensesIds: p.expensesIds ?? p.ExpensesIds ?? [],
                }))
                .filter((p) => p.id)
                .sort((a, b) => compareProjectCodes(a, b));
            setSegmentationProjects(mapped);
        } catch (e) {
            console.error(e);
            toast.error(t('ErrorRetrievingProjects'));
        } finally {
            setLoadingSegmentations(false);
        }
    }, [client?.caseId, token, t, compareProjectCodes]);

    const handleByProjectsFilterToggle = async (active) => {
        if (!active) {
            setByProjectsFilterActive(false);
            setSelectedFromSegmentation(null);
            setSelectedToSegmentation(null);
            return;
        }
        setByProjectsFilterActive(true);
        setSelectedFromSegmentation(null);
        setSelectedToSegmentation(null);
        await loadSegmentationProjects();
    };

    const handleFromSegmentationChange = (_, newVal) => {
        if (!byProjectsFilterActive) return;
        let from = newVal;
        let to = selectedToSegmentation;
        if (from && to && compareProjectCodes(from, to) > 0) {
            toast.info(t('ProjectRangeAdjustedToCodeOrder'));
            const tmp = from;
            from = to;
            to = tmp;
            setSelectedToSegmentation(to);
        }
        setSelectedFromSegmentation(from);
    };

    const handleToSegmentationChange = (_, newVal) => {
        if (!byProjectsFilterActive) return;
        let to = newVal;
        let from = selectedFromSegmentation;
        if (from && to && compareProjectCodes(from, to) > 0) {
            toast.info(t('ProjectRangeAdjustedToCodeOrder'));
            const tmp = to;
            to = from;
            from = tmp;
            setSelectedFromSegmentation(from);
        }
        setSelectedToSegmentation(to);
    };

    const allowedSegmentationIds = useMemo(() => {
        if (!byProjectsFilterActive) return null;
        if (loadingSegmentations || !segmentationProjects.length) return null;
        const ordered = [...segmentationProjects].sort((a, b) => compareProjectCodes(a, b));
        // Keep full list visible until user picks From and/or To project
        if (!selectedFromSegmentation?.id && !selectedToSegmentation?.id) {
            return null;
        }
        const fromSeg = selectedFromSegmentation
            ? ordered.find((p) => String(p.id) === String(selectedFromSegmentation.id))
            : null;
        const toSeg = selectedToSegmentation
            ? ordered.find((p) => String(p.id) === String(selectedToSegmentation.id))
            : null;
        let fromCode = fromSeg?.code ?? null;
        let toCode = toSeg?.code ?? null;
        if (
            fromCode != null &&
            toCode != null &&
            compareProjectCodes({ code: fromCode }, { code: toCode }) > 0
        ) {
            [fromCode, toCode] = [toCode, fromCode];
        }
        const selected = ordered.filter((s) => {
            const geFrom =
                fromCode == null ||
                compareProjectCodes({ code: s.code }, { code: fromCode }) >= 0;
            const leTo =
                toCode == null ||
                compareProjectCodes({ code: s.code }, { code: toCode }) <= 0;
            return geFrom && leTo;
        });
        return new Set(selected.map((p) => String(p.id)));
    }, [
        byProjectsFilterActive,
        segmentationProjects,
        selectedFromSegmentation,
        selectedToSegmentation,
        compareProjectCodes,
        loadingSegmentations,
    ]);

    const filteredAndSortedData = useMemo(() => {
        if (data.length < 0) {
            return;
        }
        let baseData = data;
        if (showOnlyUnprocessed && client?.documentIds) {
            const unprocessedIds = type === 'Incomes' ? (client.documentIds?.incomes ?? []) : (client.documentIds?.expenses ?? []);
            baseData = unprocessedIds.length ? baseData.filter(item => unprocessedIds.includes(item.id)) : baseData;
        }
        if (allowedSegmentationIds) {
            baseData = baseData.filter((item) =>
                documentMatchesAllowedProjects(item, allowedSegmentationIds, segmentationProjects, type)
            );
        }
        const sortedData = baseData.filter((item) => {
            const query = searchQuery.toLowerCase().trim();
            if (!query) return true;
            const amountString = item?.amount?.toString();
            const sortCode = sortCodeIdOptions?.find((o) => o.sortCodeId === item?.sortCodeId);
            const sortCodeName = (item?.sortCodeName ?? sortCode?.sortCodeName)?.toLowerCase?.() || '';
            const sortCodeLabel = sortCode ? `${sortCode.sortCodeId} - ${sortCode.sortCodeName}`.toLowerCase() : '';
            const sortCodeLabelReversed = sortCode ? `${sortCode.sortCodeName} - ${sortCode.sortCodeId}`.toLowerCase() : '';
            const accountCardLabel = [item?.accountCodeId, item?.accountCodeName].filter(Boolean).join(' - ').toLowerCase();
            const accountCard = accountCardOptions?.find((o) => String(o.cardId) === String(item?.accountCodeId));
            const accountCardName = (item?.accountCodeName ?? accountCard?.name)?.toLowerCase?.() || '';
            return (
                item?.accountCodeName?.toLowerCase()?.includes(query) ||
                (item?.accountCodeId?.toString()?.includes(query)) ||
                accountCardName?.includes(query) ||
                accountCardLabel?.includes(query) ||
                amountString?.includes(query) ||
                formatDate(item?.documentDate)?.includes(query) ||
                item?.reference?.toLowerCase?.()?.includes(query) ||
                item?.sortCodeId?.toString()?.includes(query) ||
                sortCodeName?.includes(query) ||
                sortCodeLabel?.includes(query) ||
                sortCodeLabelReversed?.includes(query) ||
                item?.description?.toLowerCase?.()?.includes(query) ||
                item?.uploadNumber?.toString()?.includes(query)
            );
        });
        if (sortConfig.key) {
            sortedData.sort((a, b) => {
                if (sortConfig.type === 'newest') {
                    const highlightedIds = type === 'Incomes' ? (client.documentIds?.incomes ?? []) : (client.documentIds?.expenses ?? []);
                    const aIsHighlighted = highlightedIds.includes(a.id);
                    const bIsHighlighted = highlightedIds.includes(b.id);

                    if (sortConfig.direction === 'ascending') {
                        // Ascending: Non-highlighted (older) items first
                        if (!aIsHighlighted && bIsHighlighted) {
                            return -1; // 'a' should come before 'b' (a is older, hence "lower")
                        } else if (aIsHighlighted && !bIsHighlighted) {
                            return 1;  // 'b' should come before 'a' (b is older, hence "lower")
                        }
                    } else {
                        // Descending: Highlighted (newer) items first
                        if (aIsHighlighted && !bIsHighlighted) {
                            return -1; // 'a' should come before 'b' (a is newer, hence "higher")
                        } else if (!aIsHighlighted && bIsHighlighted) {
                            return 1;  // 'b' should come before 'a' (b is newer, hence "higher")
                        }
                    }
                } else {
                    const aValue = a[sortConfig.key] || ""; // Default to empty string if null or undefined
                    const bValue = b[sortConfig.key] || ""; // Default to empty string if null or undefined
                    if (sortConfig.type === 'number') {
                        return sortConfig.direction === 'ascending' ? aValue - bValue : bValue - aValue;
                    } else if (sortConfig.type === 'date') {
                        return sortConfig.direction === 'ascending' ? new Date(aValue) - new Date(bValue) : new Date(bValue) - new Date(aValue);
                    } else { // default to string comparison
                        return sortConfig.direction === 'ascending' ? aValue?.localeCompare(bValue) : bValue?.localeCompare(aValue);
                    }
                }
            });
        }
        return sortedData;
    }, [data, searchQuery, sortConfig, showOnlyUnprocessed, client, type, sortCodeIdOptions, accountCardOptions, allowedSegmentationIds, segmentationProjects]);

    const handleGridFilteredRowsChange = useCallback((filteredRows) => {
        setGridFilteredData((prev) => {
            const prevIds = prev?.map((r) => r.id).join('\0') ?? '';
            const nextIds = filteredRows?.map((r) => r.id).join('\0') ?? '';
            if (prevIds === nextIds && (prev?.length ?? 0) === (filteredRows?.length ?? 0)) return prev;
            return filteredRows;
        });
    }, []);

    const denseTableSource = gridFilteredData ?? filteredAndSortedData;

    const isDenseTableSubset = useMemo(() => {
        const source = denseTableSource || [];
        if (!data?.length) return false;
        if (source.length !== data.length) return true;
        const ids = new Set(source.map((r) => r.id));
        return data.some((r) => !ids.has(r.id));
    }, [data, denseTableSource]);

    useEffect(() => {
        if (isDenseTableSubset) {
            extractVatByType(denseTableSource, 0, 0, 0, null, includeVatBreakdown, true);
            return;
        }
        if (data.length > 0 || denseTableVatAggregates) {
            const eq = denseTableVatAggregates?.equipmentVatTotal ?? 0;
            const inc = denseTableVatAggregates?.incomeVatTotal ?? 0;
            const exp = denseTableVatAggregates?.expenseVatTotal ?? 0;
            extractVatByType(data, eq, inc, exp, denseTableVatAggregates, includeVatBreakdown, false);
        }
    }, [isDenseTableSubset, denseTableSource, data, denseTableVatAggregates, includeVatBreakdown]);


    // Recalculate credit/debit sum when filtered data changes (search/filter)
    useEffect(() => {
        if (!client || !data || data.length === 0 || !token) return;

        // Visible-row subset already updates the dense table locally.
        if (isDenseTableSubset) return;

        // Skip first run after initial fetch -- fetchDocuments/fetchDataOnDateRangeChange already got credit/debit
        if (!initialLoadDoneRef.current) {
            initialLoadDoneRef.current = true;
            return;
        }

        const sourceData = denseTableSource || [];
        const documentIds = sourceData.length < data.length && sourceData.length > 0
            ? sourceData.map(item => item.id)
            : null;

        if (documentIds === null) {
            return;
        }

        const timeoutId = setTimeout(() => {
            dispatch(recalculateCreditDebit({
                caseId: client.caseId,
                startDate: toISO(isRange ? startDate : sortDate),
                endDate: toISO(isRange ? endDate : sortDate),
                documentType: type,
                documentIds,
                token
            }));
        }, 500);

        return () => clearTimeout(timeoutId);
    }, [filteredAndSortedData, denseTableSource, searchQuery, client, token, isRange, startDate, endDate, sortDate, data, type, dispatch]);
    const [gridRows, setGridRows] = useState(filteredAndSortedData);

    const handleGoBack = () => {
        // Navigate back to the previous page using React Router
        // if (client) {
        //     if (client) {
        //         navigate('/client-details', { state: { client } });
        //     }
        //     // handleBack();
        // }
        goBack()
        // navigate(-1);
    };

    const handleAccountChange = (selectedOption, field, CustomDropdownFlag = false) => {
        setCompanyId(selectedOption.accountCaseId);
        if (field === 'debitAccount' || field === 'creditAccount') {
            const accountCardEditDownload = accountCardEditDownloadOptions.find(option => option.cardId === selectedOption.value);
            const name = accountCardEditDownload?.name;
            const accountCaseId = accountCardEditDownload?.accountCaseId;
            if (selectedOption.value < 0) {

                setOriginalAccountCardId(editedItem.cardId)
            }
            type === 'Incomes' ? setEditedItem({ ...editedItem, accountCodeName: name, accountCodeId: selectedOption.value, debitAccount: selectedOption.value, accountCaseId: accountCaseId }) : setEditedItem({ ...editedItem, accountCodeName: name, accountCodeId: selectedOption.value, creditAccount: selectedOption.value, accountCaseId: accountCaseId });
        } else if (field === 'accountCodeId') {
            if (selectedOption.value1 === 'AddItem') {
                setEditedAddAccountCard(true);
                setOldAccountName(editedItem.accountCodeName);
                setOldAccountCaseId(editedItem.accountCaseId);
                setOldAccountCardId(editedItem.accountCodeId);
                setEditedItem({ ...editedItem, accountCodeName: '', accountCodeId: '', accountCaseId: '' });
            }
            else {
                const accountCardEdit = accountCardEditDownloadOptions.find(option =>
                    option.cardId === (CustomDropdownFlag ? selectedOption.cardId : selectedOption.value)
                );
                const name = accountCardEdit?.name;
                const accountCaseId = accountCardEdit?.accountCaseId;
                const cardId = CustomDropdownFlag ? selectedOption.cardId : selectedOption.value;
                type === 'Incomes' ? setEditedItem({ ...editedItem, accountCodeName: name, accountCodeId: cardId, debitAccount: cardId, accountCaseId: accountCaseId }) : setEditedItem({ ...editedItem, accountCodeName: name, accountCodeId: cardId, creditAccount: cardId, accountCaseId: accountCaseId });
            }
        }
    };

    const handleSetSortDate = (date) => {
        const newDate = new Date(date.getFullYear(), date.getMonth(), 10);
        localStorage.setItem('Date', newDate);
        setSortDate(newDate);
        // Trigger effect will refetch with new sortDate
    }

    const closeDownloadModal = () => {
        setShowDownloadModal(false);
    };

    const handleRangeChange = () => {
        setIsRange(!isRange);
        localStorage.setItem('IsRange', (!isRange).toString());
        // Trigger effect will refetch with new isRange
    }

    const handleOpenInvoiceCreator = () => {
        if (client?.isActive === false) {
            toast.error(t('ClientInactiveCannotCreateDocuments'));
            return;
        }
        setChooseInvoiceModal(true);
    };

    const handleCloseInvoiceModal = () => {
        setChooseInvoiceModal(false);
    };

    // const handleOpenSpecificInvoiceCreator = (type) => {

    //     // setCurrentInvoiceCreatingType(type);
    //     setInvoiceTypeInModal(type);
    //     if (client.signature && client.invoicesNumbers) {
    //         setInvoiceTypeInModal(type);
    //         setChooseInvoiceModal(false);
    //         setInvoiceModalVisible(true);
    //     }
    //     else {
    //         setSignatureReferenceInvoiceModalVisible(true);
    //     }
    // };

    const handleOpenSpecificInvoiceCreator = (type) => {
        if (type === 'ReceiptTax' || type === 'Receipt') {
            viewDocumentCreate('/ReceiptTax', type);
        }
        else if (type === 'LawyerInvoice' || type === 'LawyerReceipt') {
            viewDocumentCreate("/CreateLawyerInvoice", type);
        }
        else {
            viewDocumentCreate("/CreateInvoice", type);
        }
    };

    const handleCloseEditAddNewAccountCardDocument = () => {
        setEditedItem({ ...editedItem, accountCodeName: oldAccountName, accountCodeId: oldAccountCardId, accountCaseId: oldAccountCaseId });
        setEditedAddAccountCard(false);
    };

    const handleEditAddAccountChange = (selectedOption, field) => {
        if (field === 'AccountCodeId') {
            type === 'Incomes' ? setEditedItem({ ...editedItem, accountCodeId: selectedOption, debitAccount: selectedOption }) : setEditedItem({ ...editedItem, accountCodeId: selectedOption, creditAccount: selectedOption });
        }
        else if (field === 'accountCodeName') {

            setEditedItem({ ...editedItem, accountCodeName: selectedOption })
        }
        else {
            setEditedItem({ ...editedItem, accountCaseId: selectedOption })

        }
    };

    const handlePriceIncludingVATChange = (event) => {
        setPriceIncludingVAT(event.target.value === 'true');
    };



    //table functions
    const headerStyle = {
        backgroundColor: '#f7f7f7',
        color: 'black',
        fontWeight: 'bold'
    }

    const tableContainerRef = useRef();
    const customScrollbarRef = useRef();



    const handleCustomScroll = (e) => {
        if (tableContainerRef.current) {
            tableContainerRef.current.scrollLeft = e.target.scrollLeft;
        }
    };

    const handleTableScroll = (e) => {
        if (customScrollbarRef.current) {
            customScrollbarRef.current.scrollLeft = e.target.scrollLeft;
        }
    };

    const synchronizeScroll = () => {
        if (tableContainerRef.current && customScrollbarRef.current) {
            customScrollbarRef.current.scrollLeft = tableContainerRef.current.scrollLeft;

        }
    };

    useEffect(() => {
        synchronizeScroll();
    }, [filteredAndSortedData]);

    useEffect(() => {
        if (tableContainerRef.current && customScrollbarRef.current) {
            customScrollbarRef.current.firstChild.style.width = `${tableContainerRef.current.scrollWidth}px`;
        }
    }, [filteredAndSortedData, tableContainerRef.current?.scrollWidth]);

    const RefreshPage = async () => {
        if (isRange)
            await fetchPageData(new Date(startDate), new Date(endDate), true)
        else
            await fetchPageData(new Date(sortDate), new Date(sortDate), false);

        await fetchDocumentsNotification(client, token);
        await dispatch(
            fetchDocumentEnums({
                caseId: client.caseId,
                accountantId: client.accountantId,
                token,
                addItemLabel: t('AddItem'),
                addAccountCardLabel: t('AddAccountCard'),
                clientName: client.name,
                forceRefetch: true,
            })
        ).unwrap();
    }

    const refreshPageRef = useRef(RefreshPage);
    refreshPageRef.current = RefreshPage;

    useEffect(() => {
        if (!editModalUpdated || !client?.caseId || !token) return undefined;
        let cancelled = false;
        (async () => {
            await refreshPageRef.current?.();
            if (!cancelled) setEditModalUpdated(false);
        })();
        return () => {
            cancelled = true;
        };
    }, [editModalUpdated, client?.caseId, token, setEditModalUpdated]);

    useEffect(() => {
        if (isDenseTableSubset) return;
        let diff = denseTableCreditDebit.debitAmount - denseTableCreditDebit.creditAmount;
        setDenseTableCreditDebitRows([{ Difference: beautifyNumber(diff), TotalCreditAccount: beautifyNumber(denseTableCreditDebit.creditAmount), TotalDebitAccount: beautifyNumber(denseTableCreditDebit.debitAmount) }]);
    }, [denseTableCreditDebit, isDenseTableSubset]);

    // Recalculate credit/debit sum when filtered data changes (search/filter)



    const handleDateChangeNew = async (newValue, type) => {
        const newDate = new Date(newValue);
        let updatedDate;

        if (type === 'year') {
            updatedDate = new Date(Date.UTC(newDate.getFullYear(), sortDate.getMonth(), 10));
        } else if (type === 'month') {
            updatedDate = new Date(Date.UTC(sortDate.getFullYear(), newDate.getMonth(), 10));
        }

        setSortDate(updatedDate);

        // Save the updated date in localStorage for persistence
        localStorage.setItem('Date', updatedDate);
        await fetchPageData(updatedDate, updatedDate, false);
    };

    const handleStartDateChangeNew = async (newValue, type) => {
        const newDate = new Date(newValue);
        let updatedDate;

        if (type === 'year') {
            updatedDate = new Date(Date.UTC(newDate.getFullYear(), startDate.getMonth(), 10));
        } else if (type === 'month') {
            updatedDate = new Date(Date.UTC(startDate.getFullYear(), newDate.getMonth(), 10));
        }


        // Save the updated date in localStorage for persistence
        localStorage.setItem('StartDate', updatedDate)

        setStartDate(updatedDate);
        if (isRange) {
            await fetchPageData(new Date(updatedDate), new Date(endDate), true);
        }
    };

    const handleEndDateChangeNew = async (newValue, type) => {
        const newDate = new Date(newValue);
        let updatedDate;

        if (type === 'year') {
            updatedDate = new Date(Date.UTC(newDate.getFullYear(), endDate.getMonth(), 10));
        } else if (type === 'month') {
            updatedDate = new Date(Date.UTC(endDate.getFullYear(), newDate.getMonth(), 10));
        }



        // Save the updated date in localStorage for persistence
        localStorage.setItem('EndDate', updatedDate)

        setEndDate(updatedDate);
        if (isRange) {
            await fetchPageData(new Date(startDate), new Date(updatedDate), true);
        }
    };

    /* 1️⃣  bring the navigation callbacks into scope */
    const {
        viewDocumentDetails,
        viewPaymentAcceptanceDetails,
        viewJournalEntryDetails,
    } = useClientNavigation(client);



    const fileInputRef = useRef();

    // Function to download selected rows as XLSX
    const handleDownloadSelectedRowsAsExcel = () => {
        // Get rows to export - if none selected, export all rows
        const rowsToExport = selectedRows.length > 0
            ? data.filter(row => selectedRows.includes(row.id))
            : filteredAndSortedData;

        if (rowsToExport.length === 0) {
            toast.info(t('NoDataToDownload'));
            return;
        }

        // Define headers mapping
        const headers = {
            accountCaseId: t('CompanyId'),
            reference2: t('Reference2'),
            reference: t('Reference'),
            confirmationNumber: t('ConfirmationNumber'),
            description: t('Description'),
            reportingMonthDate: t('MonthReportDate'),
            uploadDate: t('Upload Date'),
            documentDate: t('Document Date'),
            amount: t('Amount'),
            vat: t('VATPercentage'),
            vatAmount: t('VATAmount'),
            netAmount: t('NetAmount'),
            creditAccount: t('Credit Account'),
            debitAccount: t('Debit Account'),
            sortCodeId: t('Code ID'),
            uploadNumber: t('UploadNumber'),
        };

        // Transform the data for Excel export
        const excelData = rowsToExport.map(row => {
            const transformedRow = {};

            // Map each field with proper formatting
            Object.keys(headers).forEach(key => {
                if (key === 'uploadDate' || key === 'documentDate') {
                    transformedRow[headers[key]] = row[key] ? formatDateNew(row[key]) : '';
                } else if (key === 'reportingMonthDate') {
                    transformedRow[headers[key]] = row[key] ? formatMonthYearDate(row[key]) : '';
                } else if (key === 'amount' || key === 'vatAmount' || key === 'netAmount') {
                    // Format numbers to 2 decimal places
                    transformedRow[headers[key]] = row[key] !== null && row[key] !== undefined
                        ? Math.round((parseFloat(row[key]) || 0) * 100) / 100
                        : 0;
                } else if (key === 'creditAccount' || key === 'debitAccount') {
                    // Get account name if available
                    const option = key === 'creditAccount'
                        ? creditAccountOptions.find(opt => opt.cardId === row[key])
                        : debitAccountOptions.find(opt => opt.cardId === row[key]);
                    transformedRow[headers[key]] = option && row[key]
                        ? `${row[key]} - ${option.name}`
                        : row[key] || '';
                } else if (key === 'sortCodeId') {
                    // Get sort code name if available
                    const sortCodeOption = sortCodeIdOptions.find(opt => opt.sortCodeId === row[key]);
                    transformedRow[headers[key]] = sortCodeOption && row[key]
                        ? `${row[key]} - ${sortCodeOption.sortCodeName}`
                        : row[key] || '';
                } else {
                    transformedRow[headers[key]] = row[key] || '';
                }
            });

            return transformedRow;
        });

        // Create workbook and worksheet
        const ws = XLSX.utils.json_to_sheet(excelData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Documents');

        // Generate filename with current date and client info
        const dateStr = new Date().toISOString().split('T')[0];
        const filename = `${client?.caseId || 'Documents'}_${type}_${dateStr}.xlsx`;

        // Download the file
        XLSX.writeFile(wb, filename);

        toast.success(t('ExcelFileDownloadedSuccessfully') || 'Excel file downloaded successfully');
    };

    const buttonData = useMemo(() => {
        const canSeeBulkActions =
            !hideStatusBadge &&
            (userTypeContext?.toString() !== Constants.UserType.Client || permissionsState.Premium);

        return [
        {
            label: 'Downloads',
            isDropdown: true,
            iconColor: 'green',
            dropdownItems: [
                {
                    label: 'DownloadDocuments',
                    onClick: () => setShowDownloadModal(true),
                },
                {
                    label: 'DownloadSelectedDocuments',
                    onClick: () => handleDownloadMergedDocuments(),
                    tooltip: selectedRows.length > 0
                        ? `${t('DownloadSelectedDocuments')} (${selectedRows.length})`
                        : t('DownloadSelectedDocuments'),
                    disabled: selectedRows.length === 0 || loading,
                },
                {
                    label: 'DownloadReceptionLog',
                    displayLabel: selectedRows.length > 0
                        ? t('DownloadSelectedRowsDocumentation', { count: selectedRows.length }) ||
                            `${t('DownloadReceptionLog')} (${selectedRows.length})`
                        : t('DownloadReceptionLog'),
                    onClick: handleDownloadJournalEntryDocumentation,
                    tooltip: selectedRows.length > 0
                        ? t('DownloadSelectedRowsDocumentation', { count: selectedRows.length }) ||
                            `${t('DownloadReceptionLog')} (${selectedRows.length})`
                        : t('DownloadReceptionLog'),
                    disabled: loading,
                },
                {
                    label: 'DownloadExcelFile',
                    onClick: handleDownloadSelectedRowsAsExcel,
                },
            ],
        },

        {
            label: 'Actions',
            isDropdown: true,
            iconColor: 'green',
            dropdownItems: [
                {
                    label: 'UploadDocumentsOrAddJournalEntry',
                    onClick: () => handleOpenCreateModal(true),
                    show: !isClosedReportingMonth && client?.isActive !== false,
                },
                {
                    label: 'MultiTransferDocuments',
                    onClick: () => handleMultiTransferClick(),
                    disabled: selectedRows.length === 0 || loading,
                    show: canSeeBulkActions && (type === 'Incomes' || type === 'Expenses') && !multiTransferMode,
                },
                {
                    label: 'ContinueMultiTransfer',
                    onClick: () => handleMultiTransferClick(),
                    disabled: selectedRows.length === 0 || loading,
                    show: canSeeBulkActions && (type === 'Incomes' || type === 'Expenses') && multiTransferMode,
                },
                {
                    label: 'Cancel',
                    onClick: () => handleCancelMultiTransferMode(),
                    disabled: loading,
                    icon: () => <CloseIcon />,
                    show: canSeeBulkActions && (type === 'Incomes' || type === 'Expenses') && multiTransferMode,
                },
                {
                    label: 'GenerateDocuments',
                    onClick: handleOpenInvoiceCreator,
                    show: !isRange && !isClosedReportingMonth && type === 'Incomes' && client?.isActive !== false,
                },
                {
                    label: 'ShowDuplicates',
                    onClick: () => setShowDuplicatesModal(true),
                    icon: () => <ContentCopyIcon />,
                },
                {
                    label: 'MergeToolbarTitle',
                    onClick: () => {
                        if (selectedRows.length < 2) {
                            toast.warning(t('SelectAtLeastTwoItemsToMerge'));
                            return;
                        }
                        setShowDuplicateMergeModal(true);
                    },
                    disabled: selectedRows.length < 2 || loading,
                    show: canSeeBulkActions && (type === 'Incomes' || type === 'Expenses'),
                },
                {
                    label: 'BulkEdit',
                    onClick: () => setBulkEditOpen(true),
                    disabled: selectedRows.length === 0 || loading,
                    show: canSeeBulkActions,
                },
                {
                    label: 'BulkDelete',
                    onClick: () => handleBulkDeleteDocuments(),
                    disabled: selectedRows.length === 0 || loading,
                    show: canSeeBulkActions,
                    danger: true,
                },
                {
                    label: 'WithholdingTaxReports',
                    onClick: () => openWithholdingTaxModel?.('VAT'),
                    icon: () => <ReceiptLongIcon />,
                    show: type === 'Expenses',
                },
                {
                    label: 'CommandStatus',
                    onClick: setOpenOption,
                    disabled:
                        allowAllSelect ||
                        (selectedRows.length === 0 && !complexDepositsChecked) ||
                        (complexDepositsChecked && (debitCreditSum !== 0 || selectedRows.length === 0)),
                },
            ],
        },
        {
            label: isClosedReportingMonth ? 'OpenMonthReport' : 'CloseMonthReport',
            onClick: () => {
                if (!isClosedReportingMonth || (userTypeContext?.toString() !== Constants.UserType.Client && !permissionsState.Premium)) {
                    setActionType(isClosedReportingMonth ? 'openMonth' : 'closeMonth');
                    setIsModalVisible(true);
                }
            },
            danger: isClosedReportingMonth,
            style: {
                pointerEvents:
                    !isClosedReportingMonth || (userTypeContext?.toString() !== Constants.UserType.Client && !permissionsState.Premium)
                        ? 'auto'
                        : 'none',
                opacity:
                    !isClosedReportingMonth || (userTypeContext?.toString() !== Constants.UserType.Client && !permissionsState.Premium)
                        ? 1
                        : 0.6,

            },
            show: !isRange
        },
        {
            label: 'ManageMonthlyStatus',
            onClick: () => setShowMonthStatusModal(true),
            noTruncate: true,
            show: (userTypeContext?.toString() !== Constants.UserType.Client || permissionsState.Premium)
        },
        {
            label: 'SupplierInvoicesFromTaxAuthority',
            onClick: () => setSupplierInvoicesModalOpen(true),
            icon: () => <CloudDownloadIcon />,
            noTruncate: true,
            show: type === 'Expenses' && client?.isActive !== false,
        },
    ];
    }, [isClosedReportingMonth, isRange, type, userTypeContext, permissionsState.Premium, selectedRows, client?.isActive, loading, t, allowAllSelect, complexDepositsChecked, debitCreditSum, multiTransferMode, hideStatusBadge, openWithholdingTaxModel]);

    // const jumpButtons = useMemo(() => {
    //     const map = {
    //       Incomes: [
    //         {
    //           label: 'Expenses',
    //           onClick: () => viewDocumentDetails('Expenses'),
    //           style: { width: '100px',backgroundColor: '#f9aa2a', justifyContent: 'center' },
    //           className: 'journal-btn',      // new class


    //         },
    //         {
    //           label: 'PaymentAcceptance',
    //           onClick: () => viewPaymentAcceptanceDetails('PaymentAcceptances'),
    //           style: { width: '100px',backgroundColor: '#f9aa2a', justifyContent: 'center' },
    //           className: 'journal-btn',      // new class

    //         },
    //         {
    //             label: t('JournalEntry'),
    //             onClick: () => viewJournalEntryDetails('JournalEntries'),
    //             count: client?.documentCounts?.journalEntries ?? 0,
    //             subItems: null,
    //             style: { width: '100px',backgroundColor: '#f9aa2a', justifyContent: 'center' },
    //             className: 'journal-btn',      // new class

    //           },
    //       ],
    //       Expenses: [
    //         {
    //           label: 'Incomes',
    //           onClick: () => viewDocumentDetails('Incomes'),
    //           style: { width: '100px',backgroundColor: '#f9aa2a', justifyContent: 'center' },
    //           tag: 'div',
    //           className: 'journal-btn', 
    //         },
    //         {
    //           label: 'PaymentAcceptance',
    //           onClick: () => viewPaymentAcceptanceDetails('PaymentAcceptances'),
    //           style: { width: '100px',backgroundColor: '#f9aa2a', justifyContent: 'center' },
    //           className: 'journal-btn', 
    //         },
    //         {
    //             label: t('JournalEntry'),
    //             onClick: () => viewJournalEntryDetails('JournalEntries'),
    //             count: client?.documentCounts?.journalEntries ?? 0,
    //             subItems: null,
    //             style: { width: '100px',backgroundColor: '#f9aa2a', justifyContent: 'center' },
    //             className: 'journal-btn', 
    //           },
    //       ],
    //       PaymentAcceptances: [
    //         {
    //           label: 'Expenses',
    //           onClick: () => viewDocumentDetails('Expenses'),
    //           style: { width: '100px', backgroundColor: '#f9aa2a', color: '3f3fff'  }
    //         },
    //         {
    //           label: 'Incomes',
    //           onClick: () => viewDocumentDetails('Incomes'),
    //           style: { width: '100px',backgroundColor: '#f9aa2a', justifyContent: 'center' },
    //           className: 'journal-btn', 

    //         },
    //         {
    //             label: t('JournalEntry'),
    //             onClick: () => viewJournalEntryDetails('JournalEntries'),
    //             count: client?.documentCounts?.journalEntries ?? 0,
    //             subItems: null,
    //             style: { width: '100px',backgroundColor: '#f9aa2a', justifyContent: 'center' },
    //             className: 'journal-btn', 

    //         },
    //       ],
    //     };

    //     return map[type] ?? [];
    //   }, [type, viewDocumentDetails, viewPaymentAcceptanceDetails]);
    // const buttonData = [...baseButtons, ...jumpButtons];

    const splitInfo = useMemo(
        () => splitSelectedRows(selectedRows, data),
        [selectedRows, data],
    );

    const doMerge = async payload => {
        await DocumentService.MergeDocuments(payload, token);            // call back-end
        toast.success(t('MergeSuccess'));
        RefreshPage();
        /* optional: tell grid to clear its internal checkboxes */
        if (dataGridRef.current?.deselectRows)
            dataGridRef.current.deselectRows(payload.documentIds);
    };

    const canUseMultiTransfer =
        userTypeContext?.toString() !== Constants.UserType.Client || permissionsState.Premium;

    const resolveSelectedDocumentsForTransfer = () => {
        return filteredAndSortedData
            .filter((row) => selectedRows.includes(row.id))
            .map((row) => ({
                ...row,
                docType: row.docType || type,
                caseId: row.caseId || client?.caseId,
            }));
    };

    const handleMultiTransferClick = () => {
        if (!canUseMultiTransfer) return;

        setAllowAllSelect(true);
        setMultiTransferMode(true);

        if (selectedRows.length === 0) {
            toast.warning(t('SelectAtLeastOneDocumentToTransfer'));
            return;
        }

        const docs = resolveSelectedDocumentsForTransfer();
        const types = new Set(docs.map((d) => d.docType));
        if (types.size > 1) {
            toast.error(t('CannotTransferMixedDocumentTypes'));
            return;
        }

        setMultiTransferOpen(true);
    };

    const handleCancelMultiTransferMode = () => {
        setMultiTransferMode(false);
        setMultiTransferOpen(false);
        setSelectedRows([]);
        handleDeselect(selectedRows);
        setAllowAllSelect(false);
    };

    const handleMultiTransferComplete = ({ failedIds = [], navigated = false } = {}) => {
        setMultiTransferOpen(false);
        setMultiTransferMode(false);

        if (navigated) {
            setSelectedRows([]);
            setAllowAllSelect(false);
            return;
        }

        if (failedIds.length > 0) {
            setSelectedRows(failedIds);
            setAllowAllSelect(true);
        } else {
            setSelectedRows([]);
            setAllowAllSelect(false);
        }
    };

    const handleBulkDeleteDocuments = async () => {
        if (selectedRows.length === 0) return;

        const res = await Swal.fire({
            title: t('DeleteDocumentsConfirm', { count: selectedRows.length }),
            text: t('ThisActionCannotBeUndone'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            confirmButtonText: t('YesDelete'),
            cancelButtonText: t('Cancel'),
        });
        if (!res.isConfirmed) return;

        setLocalLoading(true);
        const result = await DocumentService.BulkDeleteDocuments(
            type,
            selectedRows,
            client.caseId,
            token
        );
        result.ok ? toast.success(t('documentDeleteSuccess')) : toast.error(t('documentDeleteError'));
        await RefreshPage();
        setLocalLoading(false);
        setSelectedRows([]);
    };

    const handleBulkPatchDocuments = async (patchOrPatches) => {
        setLocalLoading(true);

        const isBatchSave = Array.isArray(patchOrPatches);
        if (isBatchSave) {
            toast.error(t('BatchSaveNotSupportedInBulkEdit') || 'Batch save is only supported in duplicate mode');
            setLocalLoading(false);
            return;
        }

        const {
            flipAmount,
            flipCards,
            replaceDescriptionWithAccountName,
            syncProject,
            projectId,
            alignRegistrationMonthToDocumentDate,
            ...patch
        } = patchOrPatches;
        const res = await DocumentService.BulkUpdateDocuments(
            type,
            selectedRows,
            patch,
            client.caseId,
            token,
            {
                flipAmount: !!flipAmount,
                flipCards: !!flipCards,
                replaceDescriptionWithAccountName: !!replaceDescriptionWithAccountName,
                syncProject: !!syncProject,
                projectId: syncProject ? (projectId ?? null) : undefined,
                alignRegistrationMonthToDocumentDate: !!alignRegistrationMonthToDocumentDate,
            }
        );
        res.ok ? toast.success(t('documentUpdateSuccess')) : toast.error(t('documentUpdateError'));
        await RefreshPage();
        setLocalLoading(false);
        setSelectedRows([]);
    };

    const handleDownloadMergedDocuments = async () => {
        const rows = selectedRows.length > 0
            ? filteredAndSortedData.filter(row => selectedRows.includes(row.id))
            : filteredAndSortedData;

        if (rows.length === 0) {
            toast.info(t('NoDataToDownload') || t('PleaseSelectOptionForSelectedRows'));
            return;
        }

        setLocalLoading(true);
        try {
            // Filter out rows without valid documentUrl (exclude NoDocumentsPdf)
            const validRows = rows.filter(row => row.documentUrl && row.documentUrl !== NoDocumentsPdf);

            if (validRows.length === 0) {
                toast.info(t('NoDocumentsFound'));
                setLocalLoading(false);
                return;
            }

            const urls = validRows.map(r => r.documentUrl);

            // Merge PDFs
            const merged = await PDFDocument.create();
            for (const url of urls) {
                try {
                    const bytes = await fetch(url).then(r => r.arrayBuffer());
                    const srcPdf = await PDFDocument.load(bytes);
                    const pages = await merged.copyPages(srcPdf, srcPdf.getPageIndices());
                    pages.forEach(p => merged.addPage(p));
                } catch (err) {
                    console.error(`Error loading PDF from ${url}:`, err);
                    // Continue with other PDFs even if one fails
                }
            }

            // Check if we have any pages in the merged document
            if (merged.getPageCount() === 0) {
                toast.error(t('NoDocumentsFound'));
                setLocalLoading(false);
                return;
            }

            // Create blob and download
            const mergedPdfBytes = await merged.save();
            const blob = new Blob([mergedPdfBytes], { type: 'application/pdf' });
            const blobUrl = URL.createObjectURL(blob);

            // Create download link
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = `merged_documents_${new Date().getTime()}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // Clean up
            setTimeout(() => {
                URL.revokeObjectURL(blobUrl);
            }, 100);

            toast.success(t('DocumentsDownloaded'));
        } catch (err) {
            console.error('Error merging/downloading documents:', err);
            toast.error(t('MergeOrPrintFailed'));
        } finally {
            setLocalLoading(false);
        }
    };

    const handleSelectChange = ids => setSelectedRows(ids);

    const formattedAccountCardOptions = creditAccountOptions.map((option) => ({
        value: option.cardId,
        label: option.accountCaseId
            ? `${option.name} - ${option?.accountCaseId || ''}`
            : `${option.name}`,
        name: option.name,
        accountCaseId: option.accountCaseId || '',
        cardId: option.cardId,
        value1: option.value1,
        palCode: option.palCode,
        isEditable: option.isEditable
    }));

    const CustomInput2 = React.forwardRef(({ value, onClick }, ref) => (
        <button className="edit-custom-input" onClick={onClick} ref={ref}>
            {value}
        </button>
    ));
    return (
        <>
            <DraggableModal
                bigIframeModalOpen={bigIframeModalOpen}
                openedIframeUrl={openedIframeUrl}
                handleCloseIframeModal={handleCloseIframeModal}
            />

            <GroupingModeModal
                open={showMultipleFilesDialog}
                onClose={() => setShowMultipleFilesDialog(false)}
                modes={ALL_GROUPING_MODE_KEYS}
                direction={direction}
                onSelect={async (mode) => {
                    setShowMultipleFilesDialog(false);
                    await handleSaveMultipleFiles(mode);
                }}
            />



            <>
                <>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }} dir={direction}>
                        <NavigationButton
                            t={t}
                            direction={direction}
                            selectedRows={selectedRows}
                            fileInputRef={fileInputRef}
                            data={buttonData}
                        />
                    </Box>

                    {/* search */}
                    <div className={`searchFilter-bar__container document-toolbar-row ${direction}${complexDepositsChecked ? ' has-complex-totals' : ''}`}>


                        <Box className="document-filter-row" dir={direction}>
                            <TextField
                                size="small"
                                dir={direction}
                                placeholder={t('Search')}
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                className="document-search-bar"
                                variant="standard"
                                InputProps={{
                                    disableUnderline: true,
                                    className: `custom-input-box-sizing ${direction === 'ltr' ? 'ltr-input' : 'rtl-input'}`,
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon className="document-search-icon" />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                            <label className={`${headerStyles.switchRow} ${headerStyles[direction] || ''}`} dir={direction}>
                                <span>{t('DateRange')}</span>
                                <input
                                    type="checkbox"
                                    checked={isRange}
                                    onChange={handleRangeChange}
                                />
                                <span className={headerStyles.switchTrack} aria-hidden="true" />
                            </label>

                            {isRange ? (
                                <div className={headerStyles.dateSelectRange}>
                                    <div className={headerStyles.dateSelect}>
                                        <FilterMonthYearPicker
                                            year={startDate}
                                            month={startDate}
                                            onYearChange={(newYear) => handleStartDateChangeNew(newYear, 'year')}
                                            onMonthChange={(newMonth) => handleStartDateChangeNew(newMonth, 'month')}
                                            labelYear={t('StartYear')}
                                            labelMonth={t('StartMonth')}
                                            direction={direction}
                                        />
                                    </div>
                                    <div className={headerStyles.rangeDivider} />
                                    <div className={headerStyles.dateSelect}>
                                        <FilterMonthYearPicker
                                            year={endDate}
                                            month={endDate}
                                            onYearChange={(newYear) => handleEndDateChangeNew(newYear, 'year')}
                                            onMonthChange={(newMonth) => handleEndDateChangeNew(newMonth, 'month')}
                                            labelYear={t('EndYear')}
                                            labelMonth={t('EndMonth')}
                                            direction={direction}
                                        />
                                    </div>
                                </div>
                            ) : (
                                <div className={headerStyles.dateSelect}>
                                    <FilterMonthYearPicker
                                        year={sortDate}
                                        month={sortDate}
                                        onYearChange={(newYear) => handleDateChangeNew(newYear, 'year')}
                                        onMonthChange={(newMonth) => handleDateChangeNew(newMonth, 'month')}
                                        labelYear={t('Year')}
                                        labelMonth={t('Month')}
                                        direction={direction}
                                    />
                                </div>
                            )}

                            <Box className="document-data-view">
                                <span className="document-data-view__label">{t('DataView')}</span>
                                <ToggleButtonGroup
                                    value={useRegistrationMonth ? 'registration' : 'reporting'}
                                    exclusive
                                    onChange={(event, newValue) => {
                                        if (newValue !== null) {
                                            const isRegistration = newValue === 'registration';
                                            setUseRegistrationMonth(isRegistration);
                                            localStorage.setItem('UseRegistrationMonth', isRegistration.toString());
                                        }
                                    }}
                                    size="small"
                                >
                                    <ToggleButton value="reporting" aria-label="reporting month">
                                        {t('ReportingMonth')}
                                    </ToggleButton>
                                    <ToggleButton value="registration" aria-label="registration month">
                                        {t('RegistrationMonth')}
                                    </ToggleButton>
                                </ToggleButtonGroup>
                            </Box>
                        </Box>
                        <Box className="document-mode-toggles">
                            {
                                !hideStatusBadge &&
                                (userTypeContext?.toString() !== Constants.UserType.Client || permissionsState.Premium) &&
                                <>
                                    <Box className="document-mode-toggle-stack">
                                        <Box className={`document-mode-toggle${complexDepositsChecked ? ' is-checked' : ''}`}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={complexDepositsChecked}
                                                        onChange={(e) => setComplexDepositsChecked(e.target.checked)}
                                                        inputProps={{ 'aria-label': t('HandlingComplexDeposits') }}
                                                        size="small"
                                                    />
                                                }
                                                label={t('HandlingComplexDeposits')}
                                            />
                                        </Box>
                                        {complexDepositsChecked && (
                                            <span className="document-mode-toggle__totals">
                                                {t('TotalCredit')}: {beautifyNumber(creditSum)} · {t('TotalDebit')}: {beautifyNumber(debitSum)} · {t('Difference')}: {beautifyNumber(debitCreditSum)}
                                            </span>
                                        )}
                                    </Box>

                                    <Box
                                        className={`document-mode-toggle${allowAllSelect ? ' is-checked' : ''}`}
                                        data-testid="handle-all-commands-container"
                                    >
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    data-testid="handle-all-commands-checkbox"
                                                    inputProps={{ 'data-testid': 'handle-all-commands-checkbox-input' }}
                                                    checked={allowAllSelect}
                                                    onChange={(e) => {
                                                        const checked = e.target.checked;
                                                        setAllowAllSelect(checked);
                                                        if (!checked) {
                                                            setMultiTransferMode(false);
                                                            setMultiTransferOpen(false);
                                                        }
                                                    }}
                                                    size="small"
                                                />
                                            }
                                            label={t('HandleAllCommands')}
                                        />
                                    </Box>
                                    <Box className={`document-mode-toggle${showOnlyUnprocessed ? ' is-checked' : ''}`}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={showOnlyUnprocessed}
                                                    onChange={(e) => setShowOnlyUnprocessed(e.target.checked)}
                                                    inputProps={{ 'aria-label': t('ShowUnprocessedDocuments') }}
                                                    size="small"
                                                />
                                            }
                                            label={t('ShowUnprocessedDocuments')}
                                        />
                                    </Box>
                                </>
                            }


                        </Box>
                    </div>

                    {((!clientPermissionsState.CannotSeeVat || !isClient) && !Constants.TaxExemptTypes.includes(client?.caseType)) && (
                        <div className="document-kpi-strip" dir={direction}>
                            <DocumentKpiCards
                                direction={direction}
                                documentType={type}
                                vatHeaders={denseTableHeader}
                                vatRows={denseTableRows}
                                ledgerHeaders={denseTableCreditDebitHeader}
                                ledgerRows={denseTableCreditDebitRows}
                                includeOppositeVat={includeVatBreakdown}
                            >
                                <label className={`${headerStyles.switchRow} ${headerStyles[direction] || ''} document-vat-switch`} dir={direction}>
                                    <span>{t('IncludeOppositeVatInTable')}</span>
                                    <input
                                        type="checkbox"
                                        checked={includeVatBreakdown}
                                        onChange={(e) => {
                                            const checked = e.target.checked;
                                            setIncludeVatBreakdown(checked);
                                            if (isRange) fetchPageData(new Date(startDate), new Date(endDate), true, { includeVatBreakdown: checked });
                                            else fetchPageData(new Date(sortDate), new Date(sortDate), false, { includeVatBreakdown: checked });
                                        }}
                                    />
                                    <span className={headerStyles.switchTrack} aria-hidden="true" />
                                </label>
                            </DocumentKpiCards>
                        </div>
                    )}

                    {((!clientPermissionsState.CannotSeeVat || !isClient) && !Constants.TaxExemptTypes.includes(client?.caseType)) && (
                        <MissingAccountCardsAlert
                            missingCards={missingAccountCards}
                            direction={direction}
                            client={client}
                            token={token}
                            palCodes={formattedPalCodeOptions}
                            accountCardOptions={accountCardOptions}
                            fetchEnums={fetchEnumsNoParams}
                            setLoading={setLocalLoading}
                            isRange={isRange}
                            isClosedReportingMonth={isClosedReportingMonth}
                            sortCodes={sortCodeIdOptions}
                        />
                    )}
                    <InactiveClientAlert client={client} />
                    <CreateDocumentModal
                        modalVisible={modalVisible}
                        closeCreateModal={handleClose}
                        t={t} // Replace with your translation function
                        formData={formData}
                        setFormData={setFormData}
                        accountCardOptions={accountCardOptions} // Replace with actual options
                        sortCodeIdOptions={sortCodeIdOptions} // Replace with actual options
                        creditAccountOptions={creditAccountOptions} // Replace with actual options
                        debitAccountOptions={debitAccountOptions} // Replace with actual options
                        documentDate={documentDate}
                        setDocumentDate={setDocumentDate}
                        handleSave={handleSave}
                        handleClose={handleClose}
                        allFieldsFilled={allFieldsFilled}
                        autoFilling={autoFilling}
                        setAutoFilling={setAutoFilling}
                        documents={documents}
                        handleDocumentUpload={handleDocumentUpload}
                        setAddNewAccountCardDocument={setAddNewAccountCardDocument}
                        addNewAccountCardDocument={addNewAccountCardDocument}
                        type={type}
                        palCodes={formattedPalCodeOptions}
                        client={client}
                        token={token}
                        fetchEnums={fetchEnums}
                        setLoading={setLocalLoading}
                        setDocuments={setDocuments}
                        sortDate={sortDate} // Add sortDate prop
                        isClosedReportingMonth={isClosedReportingMonth}
                    />


                    {chooseInvoiceModal && (
                        <div className="create-modal-overlay document-type-modal-overlay" onClick={closeCreateInvoiceModal}>
                            <div
                                className={`document-type-modal ${selectedLanguage === 'he' || selectedLanguage === 'ar' ? 'rtl-text' : ''}`}
                                ref={modalInvoiceCreateDocumentRef}
                                onClick={(e) => e.stopPropagation()}
                            >
                                <h2 className="document-type-modal__title">{t('SelectDocumentType')}</h2>

                                <div className="document-type-modal__actions">
                                    {Constants.TaxExemptTypes.includes(client?.caseType) ? (
                                        <>
                                            <button type="button" className="document-type-modal__btn" onClick={() => handleOpenSpecificInvoiceCreator('Transaction')}>
                                                {t('Transaction')}
                                            </button>
                                            <button type="button" className="document-type-modal__btn" onClick={() => handleOpenSpecificInvoiceCreator('Receipt')}>
                                                {t('Receipt')}
                                            </button>
                                        </>
                                    ) : client?.businessField === Constants.Lawyer ? (
                                        <>
                                            <button type="button" className="document-type-modal__btn" onClick={() => handleOpenSpecificInvoiceCreator('LawyerInvoice')}>
                                                {t('LawyerInvoice')}
                                            </button>
                                            <button type="button" className="document-type-modal__btn" onClick={() => handleOpenSpecificInvoiceCreator('LawyerReceipt')}>
                                                {t('LawyerReceipt')}
                                            </button>
                                            <button type="button" className="document-type-modal__btn" onClick={() => handleOpenSpecificInvoiceCreator('CreditNote')}>
                                                {t('CreditNote')}
                                            </button>
                                        </>
                                    ) : (
                                        <>
                                            <button type="button" className="document-type-modal__btn" onClick={() => handleOpenSpecificInvoiceCreator('TaxInvoice')}>
                                                {t('TaxInvoice')}
                                            </button>
                                            <button type="button" className="document-type-modal__btn" onClick={() => handleOpenSpecificInvoiceCreator('ReceiptTax')}>
                                                {t('ReceiptTax')}
                                            </button>
                                            <button type="button" className="document-type-modal__btn" onClick={() => handleOpenSpecificInvoiceCreator('CreditNote')}>
                                                {t('CreditNote')}
                                            </button>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                    
                    {showDownloadModal && (
                        <div className="document-download-modal-overlay" onClick={closeDownloadModal}>
                            <div className="document-download-modal" onClick={(e) => e.stopPropagation()}>
                                <h4 className="download-report-title">{t('DownloadDocuments')}</h4>
                                <div className={`document-download-modal-content ${direction}`}>
                                    <div className='form-row' style={{ width: '100%', gap: '50px' }}>

                                        <div className="form-row-item">
                                            <div className="form-row-item-title">
                                                {t('enterDocumentCost')}<span className="required-asterisk">*</span>
                                            </div>
                                            <TextField
                                                fullWidth
                                                placeholder={t('enterDocumentCost')}
                                                value={downloadAmount || ''}
                                                onChange={(e) => setDownloadAmount(e.target.value)}
                                                variant="standard"
                                                InputProps={{
                                                    disableUnderline: true,
                                                    className: `custom-box-sizing-border-box ${direction}`,

                                                    sx: {
                                                        height: '48px',
                                                        padding: '0 10px',
                                                        borderRadius: '8px',
                                                        background: '#F5F5F6',
                                                        border: '1px solid transparent',
                                                        '&:focus-within': {
                                                            border: '2px solid var(--Foundation-Blue-Normal, #304FFF)',
                                                        },
                                                    },
                                                }}
                                                inputProps={{
                                                    style: {
                                                        textAlign: direction === 'ltr' ? 'left' : 'right',
                                                    },
                                                }}
                                                required
                                            />
                                        </div>

                                        {/* Account Card Select */}
                                        <div className="form-row-item">
                                            <div className="form-row-item-title">
                                                {type === "Incomes" ? t('Client Name') : t('Provider Name')}

                                            </div>
                                            <AutocompleteSelect
                                                options={accountCardEditDownloadOptions.map(option => ({ value: option.cardId, label: option.name }))}
                                                selectedValues={selectedDownloadAccountCodeId}
                                                onChange={(e, newValue) => {
                                                    if (!newValue) {
                                                        return
                                                    }
                                                    const selectedValues = newValue ? newValue.map(option => option.value) : [];
                                                    setDownloadAccountCodeId(selectedValues);
                                                    setSelectedDownloadAccountCodeId(newValue);
                                                }}
                                                placeholder={type === "Incomes" ? t('Client Name') : t('Provider Name')}
                                                isMultiple={true}
                                                width="100%"
                                            />
                                        </div>
                                    </div>
                                    <div className='form-row' style={{ width: '100%', gap: '50px' }}>
                                        {/* Start Date Picker */}
                                        <div className="form-row-item">
                                            <div className="form-row-item-title">
                                                {t('From')}
                                            </div>
                                            {/* <CustomDatePicker
                                                date={downloadStartDate ? downloadStartDate : null}
                                                onDateChange={handleDownloadStartDateChange}
                                                height="48px"
                                            /> */}
                                            <CustomMonthDatePicker
                                                onDateChange={(date) => handleDownloadStartDateChange(date)}
                                                date={downloadStartDate}
                                            // label={t("EndDate")}
                                            />
                                        </div>

                                        {/* End Date Picker */}
                                        <div className="form-row-item">
                                            <div className="form-row-item-title">
                                                {t('To')}<span className="required-asterisk">*</span>
                                            </div>
                                            {/* <CustomDatePicker
                                                date={downloadEndDate ? new Date(downloadEndDate) : null}
                                                onDateChange={handleDownloadEndDateChange}
                                                height="48px"
                                            /> */}
                                            <CustomMonthDatePicker
                                                onDateChange={(date) => handleDownloadEndDateChange(date)}
                                                date={downloadEndDate}
                                            // label={t("EndDate")}
                                            />
                                        </div>

                                    </div>

                                </div>
                                <div className="download-button-row">

                                    <div
                                        className='document-download-buttons'
                                        onClick={handleDownloadDocuments}
                                    >
                                        {t('Download')}
                                    </div>
                                    <div className="document-download-cancel-buttons" onClick={() => setShowDownloadModal(false)}>
                                        {t('close')}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {showChooseAsset && (
                        <ChooseAsset
                            date={dateForAsset}
                            open={showChooseAsset}
                            onClose={() => handleAssetClose()}
                            type={type}
                            itemId={itemToAddToAsset}
                            client={client}
                            token={token}
                            editedItemVat={editedItem.vat}
                            onAssetChosen={(assetId) => {
                                setShowChooseAsset(false);
                            }}
                            onCreateAsset={(newAsset) => {
                                setShowChooseAsset(false);
                            }}
                            fullItem={itemForAssets}
                            saleEquipment={saleEquipment}
                            clickedAsset={clickedAsset}
                            fetchEnums={fetchEnums}
                            user={user}
                            setShowAddGroupModal={handleOpenGroudAdd}
                            assetGroups={assetGroups}

                        />
                    )}

                    {showAddGroupModal && (
                        <AddAssetGroup
                            open={showAddGroupModal}
                            onClose={() => setShowAddGroupModal(false)}
                            caseId={client.caseId}
                            token={token}
                            assetGroups={assetGroups}
                            refreshAssetGroups={() => {
                                // Refresh the list
                                fetchEnums(user, token, client);
                                setShowAddGroupModal(false);
                            }}
                        />
                    )}



                    {/* current table */}
                    {!hideStatusBadge && (
                        <SelectDocumentOptionDialog
                            open={openOptions}
                            onClose={closeOptions}
                            onOptionSelect={handleOptionSelect}
                            splitInfo={splitInfo}
                            selectedRowsNumber={selectedRows.length}
                        />
                    )}

                    <DocumentDataGrid
                        t={t}
                        type={type} // or "Expenses"
                        client={client}
                        data={filteredAndSortedData}
                        subAccountantOptions={subAccountantOptions}
                        isRange={isRange} // or true based on your requirement
                        isClosedReportingMonth={isClosedReportingMonth} // or true based on your requirement
                        accountCardOptions={accountCardOptions}
                        creditAccountOptions={creditAccountOptions}
                        debitAccountOptions={debitAccountOptions}
                        sortCodeIdOptions={sortCodeIdOptions}
                        openPdfInNewTab={openPdfInNewTab}
                        formatDateNew={formatDateNew}
                        formatMonthYearDate={formatMonthYearDate}
                        beautifyNumber={beautifyNumber}
                        Constants={Constants}
                        handleDeleteClick={handleDeleteClick}
                        NoDocumentsPdf={NoDocumentsPdf}
                        handleEdit={handleEdit}
                        direction={direction}
                        setEditedItem={setEditedItem}
                        setEditingRow={setEditingRow}
                        editedItem={editedItem}
                        editingRow={editingRow}
                        handleCancel={handleCancel}
                        handleSave={handleUpdateV2}
                        setEditedPopupItem={setEditedPopupItem}
                        setCurrentRowData={setCurrentRowData}
                        setOpenInlineEditModal={setOpenInlineEditModal}
                        handleSelectRows={handleSelectRows}
                        ref={dataGridRef}
                        handleRightClickAction={handleRightClickAction}
                        complexDepositsChecked={complexDepositsChecked}
                        setDebitCreditSum={setDebitCreditSum}
                        setCreditSum={setCreditSum}
                        setDebitSum={setDebitSum}
                        permissionsState={permissionsState}
                        userTypeContext={userTypeContext}
                        allowAllSelect={allowAllSelect}
                        hideStatus={hideStatusBadge}
                        token={token}
                        filteredAndSortedData={filteredAndSortedData}
                        handleReopenEdit={handleReopenEdit}
                        byProjectsFilterActive={byProjectsFilterActive}
                        onByProjectsFilterToggle={handleByProjectsFilterToggle}
                        loadingSegmentations={loadingSegmentations}
                        projectAutocompleteOptions={segmentationProjects}
                        selectedFromSegmentation={selectedFromSegmentation}
                        selectedToSegmentation={selectedToSegmentation}
                        onFromSegmentationChange={handleFromSegmentationChange}
                        onToSegmentationChange={handleToSegmentationChange}
                        onFilteredRowsChange={handleGridFilteredRowsChange}
                    />

                </>

                <CustomDeleteConfirmationModal
                    isVisible={isModalVisible}
                    onClose={() => setIsModalVisible(false)}
                    onDelete={handleConfirm}
                    confirmMessage={getConfirmMessage()}
                    titleMessage={getTitleMessage()}
                    type={actionType}
                />
                <ToastContainer position={direction === 'rtl' ? 'top-left' : 'top-right'} rtl={direction === 'rtl'} />
                {showPageLoadingOverlay && (
                    <div className="loader-container">
                        <PuffLoader
                            size={100}        // Larger size for better visibility
                            loading={showPageLoadingOverlay}
                        />
                    </div>
                )}
                {editedItem && editedPopupItem && Object.keys(editedItem).length > 0 && (

                    <EditModal
                        editedItem={editedItem}
                        fade={fade}
                        subAccountantOptions={subAccountantOptions}
                        handlePrevious={handlePrevious}
                        handleNext={handleNext}
                        currentIndex={currentIndex}
                        filteredAndSortedData={denseTableSource}
                        NoDocumentsPdf={NoDocumentsPdf}
                        t={t}
                        handleAccountChange={handleAccountChange}
                        isRange={isRange}
                        isClosedReportingMonth={isClosedReportingMonth}
                        accountCardOptions={accountCardOptions}
                        handleChange={handleChange}
                        handleDateChange={handleDateChange}
                        CustomInput2={CustomInput2}
                        setReportingMonthDate={setReportingMonthDate}
                        handleVatRadioChange={handleVatRadioChange}
                        statusCheck={statusCheck}
                        handleRadioChange={handleRadioChange}
                        type={type}
                        editedAddAccountCard={editedAddAccountCard}
                        handleCloseEditAddNewAccountCardDocument={handleCloseEditAddNewAccountCardDocument}
                        handleEditAddAccountChange={handleEditAddAccountChange}
                        sortCodeIdOptions={sortCodeIdOptions}
                        debitAccountOptions={debitAccountOptions}
                        creditAccountOptions={creditAccountOptions}
                        handleUpdate={handleUpdate}
                        handleCancel={handleCancel}
                        handleDeleteClick={handleEditDeleteClick}
                        client={client}
                        token={token}
                        setAccountCardOptions={setAccountCardOptions}
                        setLoading={setLocalLoading}
                        setEditedAddAccountCard={setEditedAddAccountCard}
                        setEditedItem={setEditedItem}
                        handleReopenEdit={handleReopenEdit}
                        palCodes={formattedPalCodeOptions}
                        RefreshPage={RefreshPage}
                        handleAccountCardSave={handleAccountCardSave}
                        fetchEnums={fetchEnumsNoParams}
                        assets={assets}
                        assetClicked={handleAssetClicked}
                        accountCards={rows}
                        hideStatus={hideStatusBadge}
                        showForceProcess={true}

                    />

                )}
                {/* {openInlineEditModal && (
                    <DocumentDraggableDialog
                        open={openInlineEditModal}
                        onClose={() => setOpenInlineEditModal(false)}
                        data={currentRowData}
                        onSave={handleUpdateV2}
                        accountCardOptions={accountCardOptions}
                        creditAccountOptions={creditAccountOptions}
                        debitAccountOptions={debitAccountOptions}
                        sortCodeIdOptions={sortCodeIdOptions}
                        Constants={Constants}
                        type={type} // Pass the type prop
                        direction={direction}
                    />
                )} */}


                <AssetFoundDialog
                    open={showAssetFoundDialog}
                    asset={foundAsset}
                    assetGroups={assetGroups}
                    onClose={() => setShowAssetFoundDialog(false)}
                    isDraggable={true}            // or false if you don't want drag
                    caseId={client?.caseId}
                    token={token}
                    transactionId={editedItem.id}
                    fetchEnums={fetchEnumsNoParams}
                />


            </>

            <SupplierInvoicesModal
                open={supplierInvoicesModalOpen}
                onClose={() => setSupplierInvoicesModalOpen(false)}
                caseId={client?.caseId}
                accountantId={client?.accountantId}
                clientName={client?.name}
                token={token}
                initialStartDate={isRange ? startDate : sortDate}
                initialEndDate={isRange ? endDate : sortDate}
                direction={direction}
                onCompare={handleCompareSupplierInvoices}
                onImport={handleImportSupplierInvoices}
                onImported={handleSupplierInvoicesImported}
            />

            <JournalDocumentationModal
                open={openJournalDocModal}
                onClose={() => setOpenJournalDocModal(false)}
                onSubmit={onSubmitJournalDocumentation}
                initialSortBy={journalDocSortBy}
                initialSortDirection={journalDocSortDirection}
                initialTypes={type ? [type.toLowerCase()] : []}
                initialFormat={'pdf'}
                initialStartDate={isRange ? startDate : sortDate}
                initialEndDate={isRange ? endDate : sortDate}
                initialIsRange={isRange}
                selectedRows={selectedRows}
                accountCardOptions={creditAccountOptions || []}
                sortCodeOptions={sortCodeIdOptions || []}
                direction={direction}
                loading={loading}
            />

            <MultiDocumentTransferDialog
                open={multiTransferOpen}
                selectedDocuments={resolveSelectedDocumentsForTransfer()}
                fromType={type}
                token={token}
                client={client}
                setLoading={setLocalLoading}
                RefreshPage={RefreshPage}
                onClose={() => setMultiTransferOpen(false)}
                onTransferComplete={handleMultiTransferComplete}
                t={t}
            />

            <MonthStatusModal
                open={showMonthStatusModal}
                onClose={() => setShowMonthStatusModal(false)}
                caseId={client?.caseId}
                selectedYear={sortDate.getFullYear()}
                token={token}
                t={t}
                direction={direction}
                onRefresh={RefreshPage}
            />

            {bulkEditOpen && (
                <BulkEditModal
                    open={bulkEditOpen}
                    ids={selectedRows}
                    onClose={() => setBulkEditOpen(false)}
                    onSavePatch={handleBulkPatchDocuments}
                    formattedAccountCardOptions={formattedAccountCardOptions}
                    sortCodeIdOptions={sortCodeIdOptions}
                    client={client}
                    type={type}
                    accountCardOptions={accountCardOptions}
                    token={token}
                    lockedSelection={
                        selectedRows.length > 0 &&
                        selectedRows.every((id) =>
                            filteredAndSortedData.some((row) => row.id === id && row.isLocked)
                        )
                    }
                />
            )}

            <DuplicateMergeModal
                open={showDuplicateMergeModal}
                onClose={() => setShowDuplicateMergeModal(false)}
                t={t}
                direction={direction}
                rows={filteredAndSortedData}
                selectedRows={selectedRows}
                setSelectedRows={setSelectedRows}
                onMerge={doMerge}
                documentType={type === 'Expenses' ? 'Expense' : 'Income'}
                caseId={client?.caseId}
                beautifyNumber={beautifyNumber}
                formatDateNew={formatDateNew}
            />

            <DuplicateEntriesModal
                open={showDuplicatesModal}
                onClose={() => setShowDuplicatesModal(false)}
                t={t}
                direction={direction}
                creditAccountOptions={creditAccountOptions}
                debitAccountOptions={debitAccountOptions}
                loading={loading}
                fetchDuplicates={async (filter) =>
                    DocumentService.FindDuplicates(
                        client.caseId,
                        type,
                        isRange ? startDate : sortDate,
                        isRange ? endDate : sortDate,
                        token,
                        {
                            isRange,
                            useRegistrationMonth,
                            referenceLastDigits: filter?.referenceLastDigits ?? null,
                        }
                    )
                }
                onDeleteMany={async (ids, { keptIdsWithDuplicateDescription, selectedByDocType, keptByDocType } = {}) => {
                    setLocalLoading(true);
                    try {
                        const deleteGroups = selectedByDocType && Object.keys(selectedByDocType).length
                            ? selectedByDocType
                            : { [type]: ids };
                        let anyOk = false;
                        let anyFail = false;
                        for (const [docType, typeIds] of Object.entries(deleteGroups)) {
                            if (!typeIds?.length) continue;
                            const res = await DocumentService.BulkDeleteDocuments(
                                docType,
                                typeIds,
                                client.caseId,
                                token
                            );
                            if (res.ok) anyOk = true;
                            else anyFail = true;
                        }
                        if (anyOk) toast.success(t('documentDeleteSuccess'));
                        if (anyFail) toast.error(t('documentDeleteError'));

                        const clearGroups = keptByDocType && Object.keys(keptByDocType).length
                            ? keptByDocType
                            : (keptIdsWithDuplicateDescription?.length
                                ? { [type]: keptIdsWithDuplicateDescription }
                                : {});
                        for (const [docType, typeIds] of Object.entries(clearGroups)) {
                            if (!typeIds?.length) continue;
                            await DocumentService.BulkUpdateDocuments(
                                docType,
                                typeIds,
                                { description: '' },
                                client.caseId,
                                token
                            );
                        }
                        await RefreshPage();
                    } catch (err) {
                        toast.error(t('documentDeleteError'));
                    }
                    setLocalLoading(false);
                }}
            />
        </>

    );
}


export default Document;
